import React, { Fragment, useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./candidateTest.scss";
import Webcam from "react-webcam";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  validateToken,
  validateCode,
  uploadImage,
  intiateTest,
  getTestSummary,
  getQuestion,
  getQuestionDetail,
  submitAnswer,
  feedbackSubmited,
  updateTestStatus,
  submitCode,
  submitNotebook,
  getStarterCode,
  sendProctoringEvent,
  uploadCandidateTestFile,
  startAdditionalDurationTimer,
  pauseAdditionalDurationTimer,
  heartbeatAdditionalDuration,
  getViolationSummary,
  reportIssue,
  heartbeatAssessmentActivity,
  submitTypingResult,
} from "../../Redux/ActionCreators/candidateTestAction";
import TypingTestPlayer from "./TypingTestPlayer";
import { useSelector } from "react-redux";
import {
  dataURLtoFile,
  removeScript,
  StarIcon,
} from "../../utils/miscelleneous";
import { Snackbar, Alert, } from "@mui/material";
import ProgressBar from "../../utils/progressBar";
import Main from "../../utils/CodeEditor/main";
import { useTranslation } from "react-i18next";
import $ from "jquery";
const emojis = [
  {
    id: 1,
    emoji: "/images/strong-dislike.png",
    text: "Strongly Dislike",
    color: "#FC4A4A",
  },
  { id: 2, emoji: "/images/dislike.png", text: "Dislike", color: "#D86B52" },
  { id: 3, emoji: "/images/not-sure.png", text: "Not Sure", color: "#EDB325" },
  { id: 4, emoji: "/images/likes.png", text: "Like", color: "#B9BB5E" },
  {
    id: 5,
    emoji: "/images/strong-like.png",
    text: "Strongly Like",
    color: "#5EBB97",
  },
];

const allowedFileTypes = ["zip"];

const isValidFile = (file) => {
  const ext = file.name.split(".").pop().toLowerCase();
  return allowedFileTypes.includes(ext);
};

const LS_KEYS = {
  LANGUAGE_TEST_META: "language_test_meta",
  LANGUAGE_TEST_VERIFICATION: "language_test_verification_code",
  LANGUAGE_TEST_RETURN_URL: "language_test_return_url",
  LANGUAGE_TEST_IN_PROGRESS: "LANGUAGE_TEST_IN_PROGRESS",
  LANGUAGE_TEST_RESUME_DATA: "LANGUAGE_TEST_RESUME_DATA",
};


export default function CandidateTest() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const resumeFromLanguage = searchParams.get("resumeLanguageTest") === "true";

  // The invite token in the URL identifies which assessment this mount belongs to.
  const currentInviteTokenFromUrl = window.location.pathname.split("/")[2];

  const resumeData = useMemo(() => {
    try {
      return JSON.parse(
        localStorage.getItem(LS_KEYS.LANGUAGE_TEST_RESUME_DATA)
      );
    } catch {
      return null;
    }
  }, []);

  // Resume data written by an abandoned language-test redirect from a DIFFERENT
  // assessment must never hijack this one -- it was only ever keyed by presence,
  // not by which assessment it belonged to, so a stale entry could otherwise
  // force this completely unrelated test into the resume flow forever.
  const resumeDataMatchesCurrentTest =
    !!resumeData?.invitationToken &&
    resumeData.invitationToken === currentInviteTokenFromUrl;

  useEffect(() => {
    if (resumeData && !resumeDataMatchesCurrentTest) {
      console.warn("⛔ Stale language-test resume data from a different assessment — clearing");
      try {
        localStorage.removeItem(LS_KEYS.LANGUAGE_TEST_IN_PROGRESS);
        localStorage.removeItem(LS_KEYS.LANGUAGE_TEST_RESUME_DATA);
      } catch (e) { /* ignore */ }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // If this page is restored from the back/forward cache (e.g. the external
  // language-test tool returns via history.back() instead of navigating to
  // returnUrl), React never remounts and none of the effects above re-run --
  // the page just resumes exactly as it was frozen, with stale bootMode/active
  // state and without ever clearing the LANGUAGE_TEST_* markers. Chrome's
  // bfcache behavior for this same-tab external-redirect round trip diverges
  // from Safari/Firefox, so force a clean reload instead of resuming frozen state.
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  // Fallback to localStorage if available
  const resumeFromStorage =
    localStorage.getItem(LS_KEYS.LANGUAGE_TEST_IN_PROGRESS) === "true" &&
    resumeDataMatchesCurrentTest;

  // Single source of truth
  const hasResumeData =
    !!localStorage.getItem(LS_KEYS.LANGUAGE_TEST_RESUME_DATA) &&
    resumeDataMatchesCurrentTest;

  const isLanguageResume = resumeFromLanguage || resumeFromStorage || hasResumeData;

  const [isCookie, setIsCookie] = useState(false);
  const [active, setActive] = useState(isLanguageResume ? "test-summary" : "summary");
  const [bootMode, setBootMode] = useState(isLanguageResume ? "RESUME" : "NORMAL");
  const [isBrowser, setIsBrowser] = useState(true);
  const [isOs, setIsOs] = useState(true);
  const [isNetwork, setIsNetwork] = useState(true);
  const [isScreen, setIsScreen] = useState(true);
  const [checked, setChecked] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [identity, setIdentity] = useState("");
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [btnloading, setBtnLoading] = useState(false);
  const [option, setOption] = useState("");
  const [qid, setQid] = useState("");
  const [nextLoading, setNextLoading] = useState(false);
  const [captureCount, setCaptureCount] = useState(0);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [ratingError, setRatingError] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  const [successMessageText, setSuccessMessageText] = useState("");
  const [show, setShow] = useState(false);
  const [isAllow, setIsAllow] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [timer, setTimer] = useState(10);
  const [isRunning, setIsRunning] = useState(false);
  const [loadingFeedback, setLoadingFeedback] = useState(false);
  const [activeEmoji, setActiveEmoji] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const [answerText, setAnswerText] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const [reason, setReason] = useState("");
  const [showFullscreenPopup, setShowFullscreenPopup] = useState(false);
  const [fullscreenPopupStep, setFullscreenPopupStep] = useState(1);
  const [liveTimeLeft, setLiveTimeLeft] = useState(0);
  const [showViolationLimitPopup, setShowViolationLimitPopup] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [languageReturnLoading, setLanguageReturnLoading] = useState(false);
  const [questionLoading, setQuestionLoading] = useState(false);
  const [processingState, setProcessingState] = useState(null);
  const [evaluationMessage, setEvaluationMessage] = useState("");
  const [nextStageId, setNextStageId] = useState(null);
  const [nextStageEventType, setNextStageEventType] = useState(null);
  const [nextStageLink, setNextStageLink] = useState(null);
  const [wsWaiting, setWsWaiting] = useState(false);
  const [isOffline, setIsOffline] = useState(false);
  const [retrySnackbar, setRetrySnackbar] = useState({ open: false, message: "" });
  const [showExtendedDurationPopup, setShowExtendedDurationPopup] = useState(false);
  const [violationSummary, setViolationSummary] = useState(null);
  const [violationSummaryLoading, setViolationSummaryLoading] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportIssueType, setReportIssueType] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [reportIssueTypeError, setReportIssueTypeError] = useState("");
  const [reportDescriptionError, setReportDescriptionError] = useState("");
  const [reportSubmitting, setReportSubmitting] = useState(false);
  const [reportSubmitSuccess, setReportSubmitSuccess] = useState(false);
  const [showCameraErrorPopup, setShowCameraErrorPopup] = useState(false);

  const dispatch = useDispatch();

  const {
    candidateDetails,
    testDetails,
    token,
    testSummary,
    question,
    isTestCompleted,
    isNextTest,
    isProctoringEnabled: isProctoringEnabledFromStore,
  } = useSelector((state) => state.candidateTest);

  // Proctoring is ON unless the assessment settings explicitly turned it off.
  // Falls back to the sessionStorage value written by the VALIDATE_TOKEN reducer
  // so it survives a mid-test reload.
  const isProctoringEnabled =
    isProctoringEnabledFromStore ??
    (sessionStorage.getItem("IS_PROCTORING_ENABLED") === "false" ? false : true);

  // A phone/tablet is only allowed into the flow when proctoring is off.
  const isSmallDevice = useMemo(
    () =>
      typeof window !== "undefined" &&
      (window.matchMedia("(pointer: coarse)").matches ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )),
    []
  );

  const codingNav = useSelector(state => state.codingNav);

  const isCodingOrDb = [7, 12, 13].includes(question?.questionTypeID);

  const activeQuestion = isCodingOrDb && codingNav.isActive ? codingNav.history[codingNav.currentIndex] : question;

  const isNotebook = [14].includes(question?.questionTypeID);
  const isJupyter = question?.questionTypeID === 13;
  const isFileUploadQ14 = question?.questionTypeID === 14;

  const authToken = token || sessionStorage.getItem("token");
  const invitationToken = candidateDetails?.invitationToken || sessionStorage.getItem("CANDIDATE_INVITATION_TOKEN");

  const resumeCandidateTestId = candidateDetails?.candidateTestId || (resumeDataMatchesCurrentTest ? resumeData?.candidateTestId : null) || sessionStorage.getItem("CANDIDATE_TEST_ID");

  const starterCode = useSelector((state) => state.candidateTest?.starterCode);

  const isStubEditor = question?.questionTypeID === 7 && starterCode?.useStub === true;

  useEffect(() => {
    if (resumeCandidateTestId && bootMode !== "RESUME") {
      setBootMode("RESUME");
    }
  }, [resumeCandidateTestId]);

  useEffect(() => {
    if (!isLanguageResume || bootMode !== "RESUME") return;

    // Can't actually resume (no candidateTestId / auth) — drop the resume
    // markers and fall back to a normal token validation so the loading
    // spinner doesn't hang forever.
    if (!resumeCandidateTestId || !authToken) {
      console.warn("⛔ Language resume not possible — falling back to normal load");
      try {
        localStorage.removeItem(LS_KEYS.LANGUAGE_TEST_IN_PROGRESS);
        localStorage.removeItem(LS_KEYS.LANGUAGE_TEST_RESUME_DATA);
      } catch (e) { /* ignore */ }
      window.history.replaceState({}, "", window.location.pathname);
      setBootMode("NORMAL");
      // active was locked to "test-summary" at mount by the (now-abandoned)
      // resume attempt -- reset it so the normal token-validation effect below
      // actually runs instead of rendering an empty test-summary screen.
      setActive("summary");
      setLoading(false);
      return;
    }

    let alive = true;

    (async () => {
      try {
        // 🔒 Hard lock UI
        setLanguageReturnLoading(true);
        setLoading(true);
        setActive("test-summary");

        // 1️⃣ Fetch latest summary
        const summaryRes = await dispatch(getTestSummary(resumeCandidateTestId, authToken));

        const summary = summaryRes?.payload;

        // 2️⃣ Find in-progress test
        const activeTest = summary?.testDetails?.tests?.find(
          (t) => t.candidateTestStatus === 2
        );

        // 3️⃣ Mark it completed
        if (activeTest?.candidateTestDetailId) {
          await dispatch(
            updateTestStatus(
              {
                candidateTestDetailId: activeTest.candidateTestDetailId,
                status: 3,
              },
              authToken
            )
          );
        }
        await dispatch(getTestSummary(resumeCandidateTestId, authToken));

        const res = await dispatch(getQuestion(invitationToken, authToken));

        if (res.payload.isTestCompleted) {
          await setActive("feedback");
        } else if (res.payload?.isNextTest) {
          setActive("test-summary");
          translatePage("en");
        } else {
          await setActive("test");
          await translatePage(
            testSummary?.testDetails?.tests?.filter(
              (el) => el.candidateTestStatus === 2
            )[0]?.languageCode
          );
        }
      } catch (err) {
        console.error("❌ Language resume failed", err);
      } finally {
        localStorage.removeItem(LS_KEYS.LANGUAGE_TEST_IN_PROGRESS);
        localStorage.removeItem(LS_KEYS.LANGUAGE_TEST_RESUME_DATA);

        window.history.replaceState({}, "", window.location.pathname);
        if (alive) {
          setBootMode("NORMAL");
          setLanguageReturnLoading(false);
          setLoading(false);
        }
      }
    })();

    return () => {
      alive = false;
    };
  }, [isLanguageResume, resumeCandidateTestId, bootMode, dispatch, authToken]);

  useEffect(() => {
    if (isNotebook) {
      setIsRunning(false);
    }
  }, [isNotebook]);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    if (active !== "test") return;
    // The window-size heuristic is meaningless on mobile browser chrome.
    if (isSmallDevice) return;
    let alerted = false;
    const checkDevTools = () => {
      const threshold = 200;
      const isOpen =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;
      if (isOpen && !alerted) {
        alerted = true;
        setSuccessMessage(true);
        setSuccessMessageText("Developer tools are not allowed during the test.");
      } else if (!isOpen) {
        alerted = false;
      }
    };
    const interval = setInterval(checkDevTools, 1500);
    return () => clearInterval(interval);
  }, [active, isSmallDevice]);

  const goFullScreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen().catch(err => {
      });
    } else if (element.mozRequestFullScreen) { // Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) { // Safari
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { // IE/Edge
      element.msRequestFullscreen();
    }
  };

  const parsedQuestionData = useMemo(() => {
    try {
      return question?.data ? JSON.parse(question.data) : null;
    } catch {
      return null;
    }
  }, [question]);

  const displayedFile = uploadedFile || parsedQuestionData?.files?.[0] || null;

  useEffect(() => {
    if (active === "feedback" || active === "test-complete") {
      clearInterval(timerIntervalRef.current);
      timerIntervalRef.current = null;
    }
    if (active === "feedback") {
      setWsWaiting(true);
      wsWaitTimerRef.current = setTimeout(() => {
        setWsWaiting(false);
      }, 10000);
    }
    return () => {
      clearTimeout(wsWaitTimerRef.current);
    };
  }, [active]);

  useEffect(() => {
    if ([7, 12, 13, 15].includes(question?.questionTypeID)) {
      document.body.setAttribute("translate", "no");
    } else {
      document.body.removeAttribute("translate");
    }
  }, [question?.questionTypeID]);


  useEffect(() => {
    // The language-test resume flow runs its own bootstrap (and clears the
    // loading spinner itself). Any other entry — a fresh open OR a plain
    // mid-test refresh — must validate the token here, even if another effect
    // has since flipped bootMode to "RESUME" because CANDIDATE_TEST_ID is
    // already in sessionStorage. Gating this on bootMode left the spinner stuck
    // forever on such refreshes (most visible on mobile).
    if (isLanguageResume) {
      return;
    }

    const firstRender = async () => {
      const inviteToken = window.location.pathname.split("/")[2];

      if (inviteToken) {
        if (active === "summary") {
          const res = await dispatch(validateToken(inviteToken));
          if (res?.type === "VALIDATE_TOKEN") {
            setIsCookie(true);
            setCode(res?.payload?.invitation?.verificationCode);
            setName(res.payload.invitation?.name);
            if (res.payload?.test?.testStatus === 3) {
              setActive("test-complete");
            }
          } else if (res?.type === "LINK_EXPIRE") {
            console.warn("❌ LINK_EXPIRE");
            setShow(true);
            setMessage(t("Link Expired.Please contact your admin."));
          }
        }
        setLoading(false);
      }

      if (active === "diagnostic") {
        const { browser, operatingSystem, networkSpeed } =
          checkEnvironment();
        if (browser === "Unknown") {
          setIsBrowser(false);
        } else if (operatingSystem === "Unknown") {
          setIsOs(false);
        } else if (networkSpeed === "Unknown" || networkSpeed === "2g") {
          setIsNetwork(false);
        }
      }
    };
    firstRender();
  }, [isLanguageResume]);

  useEffect(() => {
    // Proctoring is off — no camera is needed, so don't prompt for it (this
    // effect also re-runs when the page remounts after a language test, which
    // would otherwise pop the native camera prompt / denied modal on feedback).
    if (!isProctoringEnabled) return;

    // Check if the browser supports webcam
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setSuccessMessage(true);
      setSuccessMessageText(
        "Webcam is not supported by this device or browser."
      );
      return;
    }

    // Request access to the webcam
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        // Set the video source to the webcam stream
        if (webcamRef.current) {
          // videoRef.current.srcObject = stream;
        }
      })
      .catch((err) => {
        // Handle errors (e.g., permission denied, no webcam)
        if (err.message === "Permission denied") {
        } else {
          setIsAllow(true);
          setError(err.message);
        }
      });
  }, [active === "diagnostic", isProctoringEnabled]);

  useEffect(() => {
    if (question?.questionTypeID === 13) {
      sessionStorage.setItem("isNotebook", "true");
    } else {
      sessionStorage.removeItem("isNotebook");
    }
  }, [question?.questionTypeID]);

  const handleAutoCloseViolation = () => {
    clearInterval(timerIntervalRef.current);
    violationLimitExceededRef.current = true;
    setShowViolationLimitPopup(true);
  };

  const handleProctoringAcknowledge = async () => {
    const vType = violationTypeRef.current;

    if (!vType) {
      // Key-restriction popup — no proctoring event needed
      setShowFullscreenPopup(false);
      setFullscreenPopupStep(1);
      goFullScreen();
      return;
    }

    const duration =
      vType === "NAVIGATION"
        ? (pendingProctoringDurationRef.current || 0)
        : (violationStartRef.current ? (Date.now() - violationStartRef.current) / 1000 : 0);

    if (vType === "WINDOW") violationStartRef.current = null;
    pendingProctoringDurationRef.current = null;

    setFullscreenPopupStep(2);
    setViolationSummary(null);
    setViolationSummaryLoading(true);

    const res = await dispatch(
      sendProctoringEvent(
        { candidateTestId: resumeCandidateTestId, eventType: vType, duration },
        authToken
      )
    );

    if (res?.isAutoClosed) {
      setShowFullscreenPopup(false);
      setFullscreenPopupStep(1);
      setViolationSummaryLoading(false);
      violationTypeRef.current = null;
      handleAutoCloseViolation();
      return;
    }

    if (res) {
      try {
        const summaryRes = await dispatch(
          getViolationSummary(invitationToken, resumeCandidateTestId, authToken)
        );
        if (summaryRes?.payload) setViolationSummary(summaryRes.payload);
      } finally {
        setViolationSummaryLoading(false);
      }
    } else {
      setViolationSummaryLoading(false);
    }
  };

  const handleReturnToTest = () => {
    const wasNavigation = violationTypeRef.current === "NAVIGATION";
    violationTypeRef.current = null;
    pendingProctoringDurationRef.current = null;
    setShowFullscreenPopup(false);
    setFullscreenPopupStep(1);
    setViolationSummary(null);
    if (wasNavigation) {
      resumeWebcamStream();
    } else {
      goFullScreen();
    }
  };

  useEffect(() => {

    // BLOCK EXITING FULLSCREEN
    const handleFullscreenChange = async () => {
      // For questionTypeID 14 (Notebook), skip violation tracking
      if (question?.questionTypeID === 14) return;
      // Mobile browsers don't support real fullscreen — don't trap the
      // candidate behind a "return to fullscreen" popup they can't satisfy.
      if (isSmallDevice) return;
      // Violation Limit Exceeded popup is showing — stop all proctoring detection
      if (violationLimitExceededRef.current) return;

      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        setSuccessMessage(true);
        setSuccessMessageText("Exiting Full Screen is not allowed.");
        violationTypeRef.current = "WINDOW";
        setFullscreenPopupStep(1);
        setShowFullscreenPopup(true);
        violationStartRef.current = Date.now();
      }
    };

    // For questionTypeID 14: force fullscreen on any click if not already fullscreen
    const handleClickForceFullscreen = () => {
      if (question?.questionTypeID === 14 && !document.fullscreenElement && !document.webkitFullscreenElement) {
        goFullScreen();
      }
    };

    // ATTACH EVENT LISTENERS
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);
    document.addEventListener("click", handleClickForceFullscreen);

    // CLEANUP
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
      document.removeEventListener("click", handleClickForceFullscreen);
    };
  }, [isNotebook, token, candidateDetails, active, question?.questionTypeID, isSmallDevice]);


  useEffect(() => {
    if (isNotebook) return;
    // if (!isStubEditor) return;
    if (active !== 'test') return;
    const allowedKeys = new Set([
      'Escape', // allow escape
      'Ctrl', //allow Ctrl
      ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)), // A-Z
      ...Array.from({ length: 10 }, (_, i) => i.toString()), // 0-9
      ...[
        'Space', 'Minus', 'Equal', 'BracketLeft', 'BracketRight', 'Backslash',
        'Semicolon', 'Quote', 'Comma', 'Period', 'Slash', 'Backquote'
      ]
    ]);

    const handleKeyDown = (e) => {
      // if (e.target.closest(".ace_editor")) {
      //   return;
      // }
      // Violation Limit Exceeded popup is showing — stop all proctoring detection
      if (violationLimitExceededRef.current) return;

      const key = e.key.toUpperCase();

      // Detect OS
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

      // Block system-level / navigation shortcuts
      const restricted =
        e.altKey || e.ctrlKey || e.metaKey ||                // all system modifiers
        ['F5', 'F11', 'F12', 'PrintScreen', 'Tab'].includes(e.key) ||
        (isMac && (                                         // macOS-specific system shortcuts
          (e.metaKey && ['Q', 'W', 'M', 'H', 'TAB'].includes(key)) // Cmd+Q/W/M/H/Tab
        )) ||
        (!isMac && (                                        // Windows/Linux-specific
          (e.altKey && key === 'TAB') ||                    // Alt+Tab
          (e.ctrlKey && key === 'TAB') ||                   // Ctrl+Tab
          (e.ctrlKey && key === 'W')                        // Ctrl+W closes tab
        ));

      if (restricted) {
        e.preventDefault();
        e.stopPropagation();
        setSuccessMessage(true);
        setSuccessMessageText("System shortcuts are disabled during the test.");
        violationTypeRef.current = null;
        setFullscreenPopupStep(1);
        setShowFullscreenPopup(true);
        return false;
      }

      // Allow only valid keys
      if (!allowedKeys.has(key) && !/[a-zA-Z0-9 `~!@#$%^&*()_\-+={}[\]|:;"'<>,.?/]/.test(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const blockContext = (e) => {
      if (e.target.closest("#leftPane")) return; // allow right-click in QuestionDescription (type 13 only)
      e.preventDefault();
    };

    // Detect window/tab switch
    const handleVisibilityChange = async () => {
      // Violation Limit Exceeded popup is showing — stop all proctoring detection
      if (violationLimitExceededRef.current) return;

      if (document.visibilityState !== "visible") {
        setSuccessMessage(true);
        setSuccessMessageText("Tab or window switching is not allowed.");
        violationTypeRef.current = "NAVIGATION";
        setFullscreenPopupStep(1);
        setShowFullscreenPopup(true);
        violationStartRef.current = Date.now();

        // Blink the tab title to prompt the user to return
        const originalTitle = document.title;
        let blink = true;
        titleBlinkIntervalRef.current = setInterval(() => {
          document.title = blink ? "⚠️ Please return to the test!" : originalTitle;
          blink = !blink;
        }, 1000);
      } else if (violationStartRef.current) {
        // Stop blinking and restore the original title
        if (titleBlinkIntervalRef.current) {
          clearInterval(titleBlinkIntervalRef.current);
          titleBlinkIntervalRef.current = null;
          document.title = "Gappeo";
        }

        const durationSec = (Date.now() - violationStartRef.current) / 1000;
        violationStartRef.current = null;
        pendingProctoringDurationRef.current = durationSec;

        resumeWebcamStream();
      }
    };

    // Attach listeners when test starts
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", blockContext);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup on test end or unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", blockContext);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (titleBlinkIntervalRef.current) {
        clearInterval(titleBlinkIntervalRef.current);
        titleBlinkIntervalRef.current = null;
        document.title = "Gappeo";
      }
    };
  }, [active]);

  useEffect(() => {
    if (testSummary) {
      extendedDurationRef.current = {
        total: testSummary.totalExtendedDurationSec || 0,
        remaining: testSummary.extendedDurationRemainingSec || 0,
      };
    }
  }, [testSummary]);

  useEffect(() => {
    if (active === "test-summary" && !browserEventSentRef.current) {
      browserEventSentRef.current = true;
      dispatch(
        sendProctoringEvent(
          {
            candidateTestId: resumeCandidateTestId,
            eventType: "BROWSER",
            duration: 0,
          },
          authToken
        )
      );
    }
  }, [active, authToken, dispatch, resumeCandidateTestId]);

  useEffect(() => {
    if (isNotebook) return;

    const blockNavigation = (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", blockNavigation);

    return () => {
      window.removeEventListener("popstate", blockNavigation);
    };
  }, []);

  useEffect(() => {
    if (isNotebook) return;

    if (active !== "summary" && active !== "diagnostic") {
      goFullScreen();
    }
  }, [active, isNotebook]);

  useEffect(() => {
    const jobCandidateId = candidateDetails?.jobCandidateId;
    const baseUrl = process.env.REACT_APP_WS_URL;

    if (!jobCandidateId || !baseUrl) return;

    intentionalCloseRef.current = false;

    const connect = () => {
      if (intentionalCloseRef.current) return;

      const wsUrl = `${baseUrl}?job_candidate_id=${encodeURIComponent(jobCandidateId)}`;
      const socket = new WebSocket(wsUrl);
      socketRef.current = socket;

      socket.onopen = () => {
        reconnectAttemptsRef.current = 0;
      };

      socket.onmessage = (event) => {
        try {
          const parsed = JSON.parse(event.data);
          if (parsed.type === "ai_assessments.completed" && parsed.data) {
            const data = parsed.data;
            clearTimeout(wsWaitTimerRef.current);
            if (data.is_eligible_for_next_stage) {
              setEvaluationMessage(data.message || "You are eligible for next stage");
              awaitingNotificationRef.current = true;
              setWsWaiting(false);
              setProcessingState("evaluating");
            } else {
              setWsWaiting(false);
              setProcessingState("done");
            }
          }
          if (parsed.type === "notification" && parsed.data) {
            const stageId = parsed.data?.meta_data?.job_candidate_hiring_id;
            const eventType = parsed.data?.event_type;
            const eligibleEventTypes = [
              "telephonic_screening.assigned",
              "pre_screening.scheduled",
              "video_interview.scheduled",
            ];
            if (stageId && eligibleEventTypes.includes(eventType)) {
              awaitingNotificationRef.current = false;
              clearTimeout(wsWaitTimerRef.current);
              setNextStageId(stageId);
              setNextStageEventType(eventType);
              if (eventType === "pre_screening.scheduled") {
                setNextStageLink(parsed.data?.meta_data?.data?.prescreen?.pre_screen_id || null);
              } else if (eventType === "video_interview.scheduled") {
                setNextStageLink(parsed.data?.meta_data?.data?.video_call?.video_call_id || null);
              }
              setWsWaiting(false);
              setProcessingState("eligible");
            }
          }
        } catch (err) {
          console.error("Error parsing WebSocket message:", err);
        }
      };

      socket.onclose = () => {
        if (intentionalCloseRef.current) return;
        if (reconnectAttemptsRef.current >= MAX_RECONNECT_ATTEMPTS) {
          console.warn("WebSocket: max reconnect attempts reached");
          return;
        }
        const delay = Math.min(30000, 1000 * Math.pow(2, reconnectAttemptsRef.current));
        reconnectAttemptsRef.current += 1;
        reconnectTimerRef.current = setTimeout(connect, delay);
      };

      socket.onerror = () => {
        socket.close();
      };
    };

    connect();

    return () => {
      intentionalCloseRef.current = true;
      clearTimeout(reconnectTimerRef.current);
      if (socketRef.current) socketRef.current.close();
    };
  }, [candidateDetails?.jobCandidateId]);

  const changeActive = (val) => {
    setActive(val);
  };

  const validate = async () => {
    if (name.trim("") === "") {
      setNameError(t(`Name can't empty`));
    } else if (code === "") {
      setCodeError(t(`code can't empty`));
    } else if (code?.length > 6) {
      setCodeError(t("Code must be 6 digits"));
    } else if (code?.length < 6) {
      setCodeError(t("Code must be 6 digits"));
    } else {
      await setBtnLoading(true);
      const res = await dispatch(
        validateCode(window.location.pathname.split("/")[2], code, name, token)
      );
      if (res?.type === "VALIDATE_CODE") {
        setActive("diagnostic");
      }
      setBtnLoading(false);
    }
  };

  const checkEnvironment = () => {
    // Check browser
    const userAgent = navigator.userAgent;
    let browser;

    if (userAgent.includes("Chrome")) {
      browser = "Google Chrome";
    } else if (userAgent.includes("Firefox")) {
      browser = "Mozilla Firefox";
    } else if (userAgent.includes("Safari")) {
      browser = "Apple Safari";
    } else if (userAgent.includes("Edge")) {
      browser = "Microsoft Edge";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
      browser = "Internet Explorer";
    } else {
      browser = "Unknown";
    }

    // Check operating system
    const platform = navigator.platform;
    let operatingSystem;

    if (/iPhone|iPad|iPod/i.test(platform) || /iPad|iPhone|iPod/i.test(userAgent)) {
      operatingSystem = "iOS";
    } else if (/Android/i.test(userAgent)) {
      operatingSystem = "Android";
    } else if (platform.includes("Win")) {
      operatingSystem = "Windows";
    } else if (platform.includes("Mac")) {
      operatingSystem = "MacOS";
    } else if (platform.includes("Linux")) {
      operatingSystem = "Linux";
    } else {
      operatingSystem = "Unknown";
    }

    // Check screen resolution
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const screenResolution = `${screenWidth}x${screenHeight}`;

    // Check network speed (basic example)
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    const networkSpeed = connection ? connection.effectiveType : "Unknown";

    // Log the results
    // You can return the results as an object if needed
    return {
      browser,
      operatingSystem,
      screenResolution,
      networkSpeed,
    };
  };

  // Call the function
  checkEnvironment();

  const webcamRef = React.useRef(null);
  const webcamRef1 = React.useRef(null);
  const violationStartRef = useRef(null);
  const questionSourceRef = useRef("API");
  const starterFetchedRef = useRef({});
  // candidateQuestionId of the question whose answer has already been submitted
  // successfully. Used by getNext() to avoid re-submitting the same answer when
  // the follow-up getQuestion() call fails (e.g. server 500) and the candidate
  // clicks "Next" again. Cleared once the next question is actually loaded.
  const submittedQidRef = useRef(null);
  const browserEventSentRef = useRef(false);
  const socketRef = useRef(null);
  const reconnectTimerRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const titleBlinkIntervalRef = useRef(null);
  const intentionalCloseRef = useRef(false);
  const awaitingNotificationRef = useRef(false);
  const wsWaitTimerRef = useRef(null);
  const popupVideoRef = useRef(null);
  const popupDivRef = useRef(null);
  // Stores the fresh candidateTestDetailId from the most recent getTestSummary response.
  // onTimesUp closes over stale component state, so a ref is the only reliable source.
  const activeTestDetailIdRef = useRef(null);
  // Always-fresh refs used by onTimesUp to submit the current coding question on timer expiry.
  const currentQuestionRef = useRef(null);
  const currentEditorStateRef = useRef(null);
  // Latest computed typing-test payload (updated on every keystroke by TypingTestPlayer)
  // so onTimesUp can submit a live snapshot if the global timer expires mid-passage.
  const typingResultRef = useRef(null);
  // Whether the typing test's most recent submitTypingResult call actually succeeded — read by
  // TypingTestPlayer's onSubmit wrapper right after getNext() so it knows whether to lock the
  // UI or let the candidate retry (e.g. if the backend call failed).
  const typingSubmitOkRef = useRef(true);
  const isExtendedTimerRef = useRef(false);
  const extendedDurationRef = useRef({ total: 0, remaining: 0 });
  // Assessment countdown state. Component-scoped (not module-level) so a stray
  // remount/duplicate call can never share state with — or orphan an interval
  // started by — another instance. timeLeft is derived from wall-clock elapsed
  // time each tick (not accumulated tick-count), so even if setInterval ticks
  // are delayed, skipped, or (were it to happen again) duplicated, the displayed
  // time can never drift faster or slower than real time.
  const timerIntervalRef = useRef(null);
  const timeLimitRef = useRef(0);
  const timeLeftRef = useRef(0);
  const sessionStartRef = useRef(null);
  const pausedMsRef = useRef(0);
  const pauseStartedAtRef = useRef(null);
  const warned120Ref = useRef(false);
  const violationTypeRef = useRef(null); // "WINDOW" | "NAVIGATION" | null (null = no proctoring event)
  const pendingProctoringDurationRef = useRef(null);
  // Once the Violation Limit Exceeded popup is shown, all proctoring detection
  // must stop (no more popups/events) until the user closes it.
  const violationLimitExceededRef = useRef(false);
  const MAX_RECONNECT_ATTEMPTS = 10;

  const retryOnNetworkFailure = async (fn, onGiveUp) => {
    const MAX_RETRIES = 5;
    const WARNING_MS = 3000;
    const RETRY_INTERVAL_MS = 10000;

    const result = await fn();
    if (result !== undefined) return result;
    if (navigator.onLine) return undefined; // API error, not network — don't retry

    // Pause the test timer while we're offline
    pauseTestTimer();

    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
      setSuccessMessage(true);
      setSuccessMessageText("Network connection lost. Please check your internet connection.");
      await new Promise(r => setTimeout(r, WARNING_MS));
      setSuccessMessage(false);
      setSuccessMessageText("");

      setRetrySnackbar({ open: true, message: "Retrying to connect..." });
      await new Promise(r => setTimeout(r, RETRY_INTERVAL_MS - WARNING_MS));
      setRetrySnackbar({ open: false, message: "" });

      const retryResult = await fn();
      if (retryResult !== undefined) {
        resumeTestTimer(); // back online and API succeeded — resume timer
        return retryResult;
      }
      if (navigator.onLine) {
        resumeTestTimer(); // back online but API error — resume timer and stop retrying
        return undefined;
      }
    }

    resumeTestTimer(); // giving up — resume timer so it doesn't stay frozen
    onGiveUp?.();
    setSuccessMessage(true);
    setSuccessMessageText("You are still offline. Please try again once you are back online.");
    return undefined;
  };

  // "ideal" (not exact) sizes: phones return a portrait stream, and forcing a
  // landscape 220x155 on it produced a zoomed/cropped preview. The 220:155
  // aspect ratio + object-fit: cover on the <Webcam> keeps the framing sane.
  const videoConstraints = {
    width: { ideal: 220 },
    height: { ideal: 155 },
    aspectRatio: { ideal: 220 / 155 },
    facingMode: "user",
  };

  const reCapture = () => {
    setIdentity("");
    // resetTimer();
  };

  // Sync the hidden proctoring webcam stream to the popup <video> element.
  // Uses a 1-second poll so it automatically re-syncs after resumeWebcamStream
  // replaces the srcObject. Never calls setState, so no re-renders occur.
  useEffect(() => {
    if (active !== "test") return;
    const syncToPopup = () => {
      const src = webcamRef3.current?.video?.srcObject;
      const popup = popupVideoRef.current;
      if (popup && src && popup.srcObject !== src) {
        popup.srcObject = src;
        popup.play().catch(() => {});
      }
    };
    syncToPopup();
    const interval = setInterval(syncToPopup, 1000);
    return () => clearInterval(interval);
  }, [active]);

  useEffect(() => {
    const q = activeQuestion;
    if (!q) return;
    if (![7, 12].includes(q.questionTypeID)) return;

    const qid = q.candidateQuestionId;
    if (!qid) return;
    if (starterFetchedRef.current[qid]) return;

    const language =
      q.editorState?.language?.value ||
      (q.questionTypeID === 12
        ? (q.databaseLanguages?.[0]?.databaseLanguage || q.languages?.[0]?.codingLanguage)
        : q.languages?.[0]?.codingLanguage);

    if (!language) return;

    starterFetchedRef.current[qid] = true;

    setQuestionLoading(true);

    // --- CHANGE START ---
    dispatch(
      getStarterCode(
        invitationToken,
        q.candidateTestId,
        qid,
        language,
        authToken
      )
    ).then((res) => {
      if (res && res.type === "GET_STARTER_CODE") {
        dispatch({
          type: "CODING_NAV_UPDATE_STARTER_CODE",
          payload: {
            ...res.payload,
            code: res.payload.useStub ? "" : res.payload.code
          }
        });
      }
      setQuestionLoading(false);
    }).catch(() => {
      setQuestionLoading(false);
    })

  }, [activeQuestion?.candidateQuestionId, question?.questionTypeID, activeQuestion?.databaseLanguages, activeQuestion?.languages, activeQuestion?.editorState]);

  // Keep currentQuestionRef always pointing at the active coding/db/notebook question
  // so that onTimesUp (a stale closure) can submit the right question when the timer expires.
  useEffect(() => {
    if (activeQuestion && [7, 12, 13, 15].includes(activeQuestion.questionTypeID)) {
      currentQuestionRef.current = activeQuestion;
    }
  }, [activeQuestion]);

  useEffect(() => {
    if (active === "test-summary" && timer === 10 && isRunning) {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
    }
  }, [active]);

  const capture = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
    var file = dataURLtoFile(imageSrc, "user.png");
    const data = new FormData();
    data.append("token", invitationToken);
    data.append("file", file);
    await dispatch(uploadImage(data, 1, token));
  };

  const goToIdentity = async () => {
    await changeActive("identity");
  };

  const videoConstraints1 = {
    width: 416,
    height: 280,
    facingMode: "user",
  };

  const captureIdentity = async () => {
    const imageSrc = webcamRef1.current.getScreenshot();
    setIdentity(imageSrc);
    setIsConfirm(true);
    var file = dataURLtoFile(imageSrc, "identity.png");
    const data = new FormData();
    data.append("token", invitationToken);
    data.append("file", file);
    await dispatch(uploadImage(data, 2, token));
    await setTimer(10);
    await setIsRunning(true);
  };

  const goAhead = async () => {
    await setNextLoading(true);
    await setIsConfirm(false);
    await getTestDetail();
    await setActive("test-summary");
    await setNextLoading(false);
  };

  const getTestDetail = async () => {
    const prevActive = active;
    try {
      const isAlreadyStarted = testDetails?.testStatus === 2 ||
        testSummary?.testDetails?.tests?.some((t) => t.candidateTestStatus === 2);

      if (isAlreadyStarted) {
        const res = await retryOnNetworkFailure(
          () => dispatch(getTestSummary(resumeCandidateTestId, authToken)),
          () => { setNextLoading(false); setActive(prevActive); }
        );

        if (!res) return;

        if (res?.type === "TEST_DETAILS") {
          setIsRunning(true);
          setTimer(10);
          setActive("test-summary");
        }

        return;
      }

      const res1 = await retryOnNetworkFailure(
        () => dispatch(intiateTest(invitationToken, token)),
        () => { setNextLoading(false); setActive(prevActive); }
      );

      if (!res1) return;

      if (res1?.type === "Test_Credit") {
        setShow(true);
        setMessage(res1?.payload || 'Unable to proceed with this assessment at the moment. Please contact your administrator.');
        return;
      }

      if (res1?.type === "INTITATE_TEST") {
        const res = await retryOnNetworkFailure(
          () => dispatch(getTestSummary(resumeCandidateTestId, authToken)),
          () => { setNextLoading(false); setActive(prevActive); }
        );
        if (!res) return;
        if (res?.type === "TEST_DETAILS") {
          setIsRunning(true);
          setTimer(10);
          setActive("test-summary");
        }
      }
    } catch (error) {
      setShow(true);
      setMessage("Something went wrong while initializing the test.");
    } finally {
      setNextLoading(false);
    }
  };

  const onTimesUp = async () => {
    stopExtendedHeartbeat();
    const prevActive = active;
    clearInterval(timerIntervalRef.current);
    timerIntervalRef.current = null;
    await setLoadingFeedback(true);
    resetTimerSession(0);

    // Auto-submit the current coding/database/notebook question when the timer expires.
    // currentQuestionRef and currentEditorStateRef are always-fresh refs that bypass the
    // stale-closure problem — they are updated on every render and every code change.
    const currentQ = currentQuestionRef.current;
    if (currentQ && !currentQ.submitted && !currentQ.isSubmitted) {
      try {
        if (currentQ.questionTypeID === 13) {
          await dispatch(submitNotebook({
            token: invitationToken,
            candidateTestId: currentQ.candidateTestId,
            candidateTestQuestionId: currentQ.candidateQuestionId,
          }, authToken));
        } else if (currentQ.questionTypeID === 7 || currentQ.questionTypeID === 12) {
          const editorState = currentEditorStateRef.current;
          const sourceCode = editorState?.code || "";
          const language = editorState?.language?.value || "";
          if (sourceCode && language) {
            await dispatch(submitCode({
              token: invitationToken,
              candidateTestId: currentQ.candidateTestId,
              candidateTestQuestionId: currentQ.candidateQuestionId,
              sourceCode,
              language,
              inputs: currentQ.inputs || [],
              output: "",
            }, authToken));
          }
        } else if (currentQ.questionTypeID === 15) {
          if (typingResultRef.current) {
            await dispatch(submitTypingResult(
              currentQ.candidateTestId,
              currentQ.candidateQuestionId,
              typingResultRef.current
            ));
          }
        }
      } catch {
        // ignore submit errors — timer expiry flow must proceed regardless
      }
    }

    dispatch({ type: "CODING_NAV_RESET" });

    const activeCodingQ = codingNav.history[codingNav.currentIndex];
    // activeTestDetailIdRef holds the value set from fresh res1.payload in startTest,
    // which avoids the stale-closure problem on testSummary for 2nd+ tests.
    const candidateTestDetailId =
      activeCodingQ?.candidateTestDetailId ||
      activeTestDetailIdRef.current ||
      testSummary?.testDetails?.tests?.find((t) => t.candidateTestStatus === 2)?.candidateTestDetailId;

    if (candidateTestDetailId) {
      const updateRes = await retryOnNetworkFailure(
        () => dispatch(updateTestStatus({ candidateTestDetailId, status: 3 }, authToken)),
        () => { setLoadingFeedback(false); setActive(prevActive); }
      );
      if (!updateRes) { await setLoadingFeedback(false); return; }
    }

    const res1 = await retryOnNetworkFailure(
      () => dispatch(getTestSummary(resumeCandidateTestId, authToken)),
      () => { setLoadingFeedback(false); setActive(prevActive); }
    );
    if (!res1) { await setLoadingFeedback(false); return; }

    if (res1?.type === "TEST_DETAILS") {
      // Status 1 = not started, 2 = in progress. The next test is still status 1
      // here, and calling getQuestion early would consume its first question.
      const hasMoreTests = res1.payload?.testDetails?.tests?.some(
        (t) => t.candidateTestStatus === 1 || t.candidateTestStatus === 2
      );

      if (!hasMoreTests) {
        // No test is pending or in progress — the timer that just expired belonged
        // to the last test in the assessment. Go straight to feedback instead
        // of always bouncing through the "next test starts in" screen.
        const qRes = await dispatch(getQuestion(invitationToken, authToken));
        if (qRes?.payload?.isTestCompleted) {
          await dispatch(getTestSummary(resumeCandidateTestId, authToken));
          changeActive("feedback");
          await setLoadingFeedback(false);
          return;
        }
      }

      await setTimer(10);
      await setIsRunning(true);
      changeActive("test-summary");
    }

    await setLoadingFeedback(false);
  };

  const translatePage = (lang) => {
    const selectElement = document.querySelector(".goog-te-combo");
    if (selectElement) {
      selectElement.value = lang;
      selectElement.dispatchEvent(new Event("change"));
    } else {
      setTimeout(function () {
        $(".goog-te-combo").val(lang);
      }, 500);
    }
  };

  const startTest = async () => {
    const prevActive = active;
    questionSourceRef.current = "API";
    starterFetchedRef.current = {};
    if (show) return;
    setIsRunning(false);
    setTimer(0);
    await setLoadingFeedback(true);

    try {
      // Check if the active test should resume from the last seen question
      // (applies to MCQ, Big Five, Rating, File Based, Essay — not coding/DB/Jupyter)
      const activeTestForResume = testSummary?.testDetails?.tests?.find(
        (t) =>
          t.candidateTestStatus === 2 &&
          t.shouldResumeLastQuestion === true &&
          t.shouldFetchNextQuestion === false &&
          t.lastQuestionId != null
      );

      let res;
      let isResumeFlow = false;

      if (activeTestForResume) {
        const countInfo = {
          currentQuestion: activeTestForResume.currentQuestionIndex,
          totalQuestion: activeTestForResume.questionCount,
        };

        const detailRes = await retryOnNetworkFailure(
          () => dispatch(getQuestionDetail(invitationToken, activeTestForResume.lastQuestionId, authToken, countInfo)),
          () => { setLoadingFeedback(false); setActive(prevActive); }
        );

        if (!detailRes) { await setLoadingFeedback(false); return; }

        const resumedQTypeID = detailRes.payload?.question?.questionTypeID;

        if ([7, 12, 13].includes(resumedQTypeID)) {
          // Coding / Database — init nav history from questionsNavigation then resume
          const navData = activeTestForResume.questionsNavigation || [];
          const isDatabase = resumedQTypeID === 12;
          const q = detailRes.payload.question;
          const langObj = isDatabase ? q?.databaseLanguages?.[0] : q?.languages?.[0];
          const normalizedLanguage = langObj
            ? { label: langObj.displayLanguage, value: isDatabase ? langObj.databaseLanguage : langObj.codingLanguage }
            : null;

          // The resumed question (q, fetched by lastQuestionId) is not necessarily
          // the last entry in navData — match by ID instead of assuming position,
          // otherwise a lagging/incomplete navData array can attribute another
          // question's submitted/order metadata to the one actually being resumed.
          const lastNavEntry = navData.find(
            (nav) => nav.candidateQuestionId === q?.candidateQuestionId
          );
          const isLastSubmitted = lastNavEntry?.isSubmitted || false;

          const lastQWithState = {
            ...q,
            candidateTestDetailId: activeTestForResume.candidateTestDetailId,
            submitted: isLastSubmitted,
            questionOrder: lastNavEntry?.questionOrder,
            currentQuestion: lastNavEntry?.questionOrder ?? activeTestForResume.currentQuestionIndex,
            totalQuestion: activeTestForResume.questionCount,
            editorState: {
              code: (isLastSubmitted && q?.execution?.sourceCode) ? q.execution.sourceCode : (q?.defaultCode || ""),
              language: normalizedLanguage,
            },
          };

          if (isLastSubmitted && q?.candidateQuestionId) {
            starterFetchedRef.current[q.candidateQuestionId] = true;
          }

          dispatch({
            type: "CODING_NAV_INIT_RESUME",
            payload: {
              testId: q?.candidateTestId,
              questionsNavigation: navData,
              lastQuestion: lastQWithState,
              totalQuestion: activeTestForResume.questionCount,
              candidateTestDetailId: activeTestForResume.candidateTestDetailId,
            },
          });

          res = {
            type: "GET_QUESTION",
            payload: {
              question: lastQWithState,
              isTestCompleted: false,
              isNextTest: false,
            },
          };
          isResumeFlow = true;
        } else {
          // MCQ, Big Five, Rating, File Based, Essay — use the resumed question
          res = {
            type: "GET_QUESTION",
            payload: {
              question: detailRes.payload.question,
              isTestCompleted: false,
              isNextTest: false,
            },
          };
          isResumeFlow = true;
        }
      } else {
        res = await retryOnNetworkFailure(
          () => dispatch(getQuestion(invitationToken, authToken)),
          () => { setLoadingFeedback(false); setActive(prevActive); }
        );
      }

      if (!res) { await setLoadingFeedback(false); return; }

      if (
        !isResumeFlow &&
        res.payload?.isNextTest &&
        res.payload?.isLanguageTest &&
        res.payload?.metaData?.data?.test_url
      ) {
        const meta = res.payload.metaData.data;
        const authToken = token;
        const candidateTestId = candidateDetails?.candidateTestId;
        const invitationToken = candidateDetails?.invitationToken;

        //  Pass returnUrl SAFELY via query param
        const returnUrl = encodeURIComponent(
          `${window.location.origin}${window.location.pathname}?resumeLanguageTest=true`
        );

        const redirectUrl =
          `${meta.test_url}` +
          `?returnUrl=${returnUrl}` +
          `&authToken=${encodeURIComponent(authToken)}` +
          `&candidateTestId=${candidateTestId}` +
          `&invitationToken=${invitationToken}` +
          `&isProctoringEnabled=${isProctoringEnabled}`;

        console.log("[language-test] redirecting to:", redirectUrl);

        localStorage.setItem("LANGUAGE_TEST_IN_PROGRESS", "true");

        localStorage.setItem(
          "LANGUAGE_TEST_RESUME_DATA",
          JSON.stringify({
            candidateTestId: candidateDetails?.candidateTestId,
            invitationToken: candidateDetails?.invitationToken,
          })
        );

        window.location.href = redirectUrl;
        return;
      }

      if (res?.type === "GET_QUESTION") {
        const q = res.payload.question;

        const res1 = await retryOnNetworkFailure(
          () => dispatch(getTestSummary(resumeCandidateTestId, authToken)),
          () => { setLoadingFeedback(false); setActive(prevActive); }
        );

        if (!res1) { await setLoadingFeedback(false); return; }

        if (res1?.type === "TEST_DETAILS") {
          const activeTest = res1.payload.testDetails.tests.find((el) => el.candidateTestStatus === 2);

          // Always keep the ref current so onTimesUp (a stale closure) can read it reliably.
          activeTestDetailIdRef.current = activeTest?.candidateTestDetailId || null;

          // Sync extended duration from the fresh summary so the correct remaining
          // time is available when this test's timer expires (covers test 2+ scenarios).
          extendedDurationRef.current = {
            total: res1.payload?.totalExtendedDurationSec || 0,
            remaining: res1.payload?.extendedDurationRemainingSec || 0,
          };

          if (!isResumeFlow && [7, 12, 13].includes(q?.questionTypeID)) {
            const isDatabase = q.questionTypeID === 12;
            const langObj = isDatabase ? q.databaseLanguages?.[0] : q.languages?.[0];
            const normalizedLanguage = langObj ? { label: langObj.displayLanguage, value: isDatabase ? langObj.databaseLanguage : langObj.codingLanguage, } : null;

            dispatch({
              type: "CODING_NAV_INIT",
              payload: {
                testId: q.candidateTestId,
                question: {
                  ...q,
                  candidateTestDetailId: activeTest?.candidateTestDetailId,
                  submitted: false,
                  editorState: {
                    code: q.defaultCode || "",
                    language: normalizedLanguage,
                  },
                },
              },
            });
          }

          let seconds;
          if (activeTest?.testRemainingTimeSec != null) {
            seconds = activeTest.testRemainingTimeSec;
          } else {
            const minute = activeTest?.duration || 0;
            seconds = Math.round(60 * minute);
          }
          resetTimerSession(seconds);

          if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
          }

          if (seconds > 0) {
            await startTimer();
          }

          if (res.payload.isTestCompleted) {
            await setActive("feedback");
          } else if (res.payload?.isNextTest) {
            setActive("test-summary");
            translatePage("en");
          } else {
            await setActive("test");
            await translatePage(
              testSummary?.testDetails?.tests?.filter(
                (el) => el.candidateTestStatus === 2
              )[0]?.languageCode
            );
          }

          if (seconds === 0 && !res.payload.isTestCompleted && !res.payload?.isNextTest) {
            extendedDurationRef.current = {
              total: res1.payload?.totalExtendedDurationSec || 0,
              remaining: res1.payload?.extendedDurationRemainingSec || 0,
            };
            handleTimerExpired();
          }
        }
      }
    } catch (error) {
      console.error("❌ Error in startTest:", error);
    }
    await setLoadingFeedback(false);
  };

  const FULL_DASH_ARRAY = 283;
  const WARNING_THRESHOLD = 60;
  const ALERT_THRESHOLD = 10;

  const COLOR_CODES = {
    info: {
      color: "black",
    },
    warning: {
      color: "orange",
      threshold: WARNING_THRESHOLD,
    },
    alert: {
      color: "red",
      threshold: ALERT_THRESHOLD,
    },
  };
  let remainingPathColor = COLOR_CODES.info.color;

  const isPausedRef = useRef(false);

  const pauseTestTimer = () => {
    if (isPausedRef.current) return;
    isPausedRef.current = true;
    pauseStartedAtRef.current = Date.now();
  };

  const resumeTestTimer = () => {
    if (!isPausedRef.current) return;
    isPausedRef.current = false;
    if (pauseStartedAtRef.current) {
      pausedMsRef.current += Date.now() - pauseStartedAtRef.current;
      pauseStartedAtRef.current = null;
    }
  };

  // Starts (or restarts) a fresh countdown period of `seconds` length, anchored
  // to the current wall-clock time. Call this instead of touching timeLimitRef /
  // timeLeftRef directly so the elapsed-time math in startTimer's tick always
  // stays consistent.
  const resetTimerSession = (seconds) => {
    timeLimitRef.current = seconds;
    timeLeftRef.current = seconds;
    sessionStartRef.current = Date.now();
    pausedMsRef.current = 0;
    pauseStartedAtRef.current = null;
    warned120Ref.current = false;
  };

  const handleTimerExpired = () => {
    const { total, remaining } = extendedDurationRef.current;
    if (total > 0 && remaining > 0) {
      setShowExtendedDurationPopup(true);
    } else {
      onTimesUp();
    }
  };

  const heartbeatIntervalRef = useRef(null);

  const stopExtendedHeartbeat = () => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current);
      heartbeatIntervalRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      stopExtendedHeartbeat();
    };
  }, []);

  const startExtendedTimer = async () => {
    setShowExtendedDurationPopup(false);
    await dispatch(startAdditionalDurationTimer(invitationToken, authToken));
    const remainingSec = extendedDurationRef.current.remaining;
    isExtendedTimerRef.current = true;
    resetTimerSession(remainingSec);
    startTimer();

    stopExtendedHeartbeat();
    heartbeatIntervalRef.current = setInterval(() => {
      dispatch(heartbeatAdditionalDuration(invitationToken, authToken));
    }, 15000);
  };

  const startTimer = () => {
    const labelCheck = document.getElementById("base-timer-label");
    if (!labelCheck) {
      console.warn("⚠️ base-timer-label not found — delaying timer start...");

      let attempts = 0;
      const waitForLabel = setInterval(() => {
        const label = document.getElementById("base-timer-label");
        attempts++;

        if (label) {
          clearInterval(waitForLabel);
          startTimer(); // recursively call after DOM is ready
        } else if (attempts >= 25) { // stop after 5s
          clearInterval(waitForLabel);
          console.error("❌ Timer label not found after waiting 5 seconds — giving up on starting timer");
        }
      }, 200);

      return;
    }

    // Idempotency guard: never let two ticking intervals run concurrently. Every
    // call site below is careful to clear timerIntervalRef first, but startTimer
    // recurses into itself (waitForLabel above, and the 120s pause below), so this
    // function must also be able to protect itself if that discipline is ever broken.
    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
      timerIntervalRef.current = null;
    }

    // If label exists — proceed with countdown logic
    timerIntervalRef.current = setInterval(() => {
      if (isPausedRef.current) return;

      // Derive time left from actual elapsed wall-clock time (minus time spent
      // paused) rather than counting ticks. This makes the countdown immune to
      // interval drift, throttled/delayed ticks, or — were it to ever happen
      // again — a duplicate interval: a stray second setInterval would recompute
      // the same elapsed time instead of double-decrementing.
      const elapsedMs = Date.now() - sessionStartRef.current - pausedMsRef.current;
      const newTimeLeft = Math.max(0, timeLimitRef.current - Math.floor(elapsedMs / 1000));
      timeLeftRef.current = newTimeLeft;

      const ele = document.getElementById("base-timer-label");
      if (!ele) {
        console.warn("⚠️ Timer label lost during interval tick — stopping timer interval");
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
        return;
      }

      ele.innerHTML = isNaN(newTimeLeft) ? "00:00" : formatTime(newTimeLeft);
      setLiveTimeLeft(newTimeLeft);
      setCircleDasharray();
      setRemainingPathColor(newTimeLeft);
      if (newTimeLeft <= 0) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
        ele.innerHTML = "00:00";
        if (isExtendedTimerRef.current) {
          isExtendedTimerRef.current = false;
          dispatch(pauseAdditionalDurationTimer(invitationToken, authToken));
          stopExtendedHeartbeat();
          onTimesUp();
        } else {
          handleTimerExpired();
        }
      } else if (newTimeLeft <= 120 && !warned120Ref.current) {
        warned120Ref.current = true;
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
        pauseTestTimer();
        setIsAlert(true);
        setTimeout(() => {
          resumeTestTimer();
          setIsAlert(false);
          startTimer();
        }, 8000);
      }
    }, 1000);
  };

  function formatTime(time) {
    const minutes = Math.floor(time / 60);
    let seconds = time % 60;

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    return `${minutes}:${seconds}`;
  }

  function setRemainingPathColor(timeLeft) {
    const { alert, warning, info } = COLOR_CODES;
    const el = document.getElementById("base-timer-path-remaining");
    if (!el) return; // ✅ prevent null error

    if (timeLeft <= alert.threshold) {
      el.classList.remove(warning.color, info.color);
      el.classList.add(alert.color);
    } else if (timeLeft <= warning.threshold) {
      el.classList.remove(info.color, alert.color);
      el.classList.add(warning.color);
    } else {
      el.classList.remove(alert.color, warning.color);
      el.classList.add(info.color);
    }
  }

  function setCircleDasharray() {
    const el = document.getElementById("base-timer-path-remaining");
    if (!el) return; // ✅ prevent null error

    const circleDasharray = `${(
      calculateTimeFraction() * FULL_DASH_ARRAY
    ).toFixed(0)} ${FULL_DASH_ARRAY}`;
    el.setAttribute("stroke-dasharray", circleDasharray);
  }

  function calculateTimeFraction() {
    const rawTimeFraction = timeLeftRef.current / timeLimitRef.current;
    return rawTimeFraction - (1 / timeLimitRef.current) * (1 - rawTimeFraction);
  }

  const selectOption = async (id, qid) => {
    setOption(id);
    setQid(qid);
  };

  const getNext = async () => {
    const prevActive = active;
    await setNextLoading(true);

    let selectedIds = [];

    if (question?.questionTypeID === 5) {
      selectedIds = [];
    } else if (question?.questionTypeID === 8) {
      selectedIds = [activeEmoji]; // Big Five
    } else if (question?.questionTypeID === 11) {
      // Rating → map emoji to questionOptionID
      const selectedOption = question?.questionOptions?.[activeEmoji - 1];
      selectedIds = selectedOption ? [selectedOption.questionOptionID] : [];
    } else if (question?.questionTypeID !== 14) {
      selectedIds = option ? [option] : [];
    } else {
      selectedIds = [option]; // MCQ, MBTI, etc.
    }

    let obj = {
      token: invitationToken,
      candidateTestQuestionId: [5, 14].includes(question?.questionTypeID) ? question?.candidateQuestionId : qid,
      selectedOptionIds: selectedIds,
      answerText: answerText,
      reason: question?.shouldProvideReason === 1 ? reason : "",
    };

    if (question?.questionTypeID === 14) {
      obj.data = JSON.stringify({ files: uploadedFile ? [{ name: uploadedFile.name, url: uploadedFile.url, },] : [], });
      obj.selectedOptionIds = [];
      obj.answerText = "";
    }

    // Skip the submit call if this exact question's answer was already saved on a
    // previous getNext() attempt that then failed at the getQuestion() step.
    const currentQKey = question?.candidateQuestionId;
    const alreadySubmitted = !!currentQKey && submittedQidRef.current === currentQKey;

    if (!alreadySubmitted) {
      const submitRes = await retryOnNetworkFailure(
        question?.questionTypeID === 15
          ? () => dispatch(submitTypingResult(question?.candidateTestId, question?.candidateQuestionId, typingResultRef.current))
          : () => dispatch(submitAnswer(obj, token)),
        () => { setNextLoading(false); setActive(prevActive); }
      );
      if (question?.questionTypeID === 15) {
        typingSubmitOkRef.current = Boolean(submitRes);
      }
      if (!submitRes) { setNextLoading(false); return; }
      if (currentQKey) submittedQidRef.current = currentQKey;
    }

    let res = await retryOnNetworkFailure(
      () => dispatch(getQuestion(invitationToken, authToken)),
      () => { setNextLoading(false); setActive(prevActive); }
    );
    // Online but the server errored (e.g. 500) — the answer is already saved, so
    // retry just the fetch a few times before giving up.
    if (!res && navigator.onLine) {
      for (let i = 0; i < 3 && !res; i++) {
        await new Promise((r) => setTimeout(r, 2000));
        res = await dispatch(getQuestion(invitationToken, authToken));
      }
    }
    if (!res) {
      // Keep the candidate on the current (already-submitted) question. Clicking
      // "Next" again will skip the submit and just re-attempt the fetch.
      if (navigator.onLine) {
        setSuccessMessage(true);
        setSuccessMessageText("Couldn't load the next question. Please click 'Next' to try again.");
      }
      setNextLoading(false);
      return;
    }

    if (
      res.payload?.isNextTest &&
      res.payload?.isLanguageTest &&
      res.payload?.metaData?.data?.test_url
    ) {
      const meta = res.payload.metaData.data;
      const authToken = token;
      const candidateTestId = candidateDetails?.candidateTestId;
      const invitationToken = candidateDetails?.invitationToken;

      //  Pass returnUrl SAFELY via query param
      const returnUrl = encodeURIComponent(
        `${window.location.origin}${window.location.pathname}?resumeLanguageTest=true`
      );

      const redirectUrl =
        `${meta.test_url}` +
        `?returnUrl=${returnUrl}` +
        `&authToken=${encodeURIComponent(authToken)}` +
        `&candidateTestId=${candidateTestId}` +
        `&invitationToken=${invitationToken}` +
        `&isProctoringEnabled=${isProctoringEnabled}`;

      console.log("[language-test] redirecting to:", redirectUrl);

      localStorage.setItem("LANGUAGE_TEST_IN_PROGRESS", "true");

      localStorage.setItem(
        "LANGUAGE_TEST_RESUME_DATA",
        JSON.stringify({
          candidateTestId: candidateDetails?.candidateTestId,
          invitationToken: candidateDetails?.invitationToken,
        })
      );

      window.location.href = redirectUrl;
      return;
    }

    if (res?.type === "GET_QUESTION") {
      // Next question loaded — the pending-submit guard is no longer needed.
      submittedQidRef.current = null;
      setOption("");
      setActiveEmoji("");
      setAnswerText("");
      setReason("");
      setUploadedFile(null);

      if (res.payload.isTestCompleted) {
        if (isExtendedTimerRef.current) {
          isExtendedTimerRef.current = false;
          dispatch(pauseAdditionalDurationTimer(invitationToken, authToken));
        }
        dispatch({ type: "CODING_NAV_RESET" });
        await setActive("feedback");
        await setLoadingFeedback(true);
        const res2 = await retryOnNetworkFailure(
          () => dispatch(getTestSummary(resumeCandidateTestId, authToken)),
          () => { setLoadingFeedback(false); setNextLoading(false); setActive(prevActive); }
        );
        if (res2?.type === "TEST_DETAILS") {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
          timeLeftRef.current = 0;
          await setActive("feedback");
        }
        setLoadingFeedback(false);
      } else if (res.payload?.isNextTest) {
        dispatch({ type: "CODING_NAV_RESET" });

        if (isExtendedTimerRef.current) {
          isExtendedTimerRef.current = false;
          dispatch(pauseAdditionalDurationTimer(invitationToken, authToken));
          stopExtendedHeartbeat();
        }

        questionSourceRef.current = "API";
        starterFetchedRef.current = {};

        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }

        timeLeftRef.current = 10;

        setTimer(10);
        setIsRunning(true);
        setActive("test-summary");
        await setLoadingFeedback(true);
        const res1 = await retryOnNetworkFailure(
          () => dispatch(getTestSummary(resumeCandidateTestId, authToken)),
          () => { setLoadingFeedback(false); setNextLoading(false); setActive(prevActive); }
        );
        if (res1?.type === "TEST_DETAILS") {
          if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
          }
          timeLeftRef.current = 0;
          setTimer(10);
          setIsRunning(true);
        }
        setLoadingFeedback(false);
      } else {
        await setActive("test");
      }
    }
    setNextLoading(false);
  };

  const getNextCodingQues = async (payload) => {
    const prevActive = active;
    const { editorState } = payload || {};
    const { history, currentIndex } = codingNav;

    if (editorState) {
      dispatch({
        type: "CODING_NAV_PERSIST_CURRENT",
        payload: { editorState },
      });
    }

    const nextEntry = history[currentIndex + 1];

    if (nextEntry) {
      questionSourceRef.current = "HISTORY";

      if (nextEntry.isPlaceholder) {
        setQuestionLoading(true);
        const countInfo = {
          currentQuestion: nextEntry.currentQuestion,
          totalQuestion: nextEntry.totalQuestion,
        };

        const detailRes = await dispatch(
          getQuestionDetail(invitationToken, nextEntry.candidateQuestionId, authToken, countInfo)
        );

        if (detailRes?.payload?.question) {
          const q = detailRes.payload.question;
          const isDatabase = q.questionTypeID === 12;
          const langObj = isDatabase ? q.databaseLanguages?.[0] : q.languages?.[0];
          const normalizedLanguage = langObj
            ? { label: langObj.displayLanguage, value: isDatabase ? langObj.databaseLanguage : langObj.codingLanguage }
            : null;

          const isAlreadySubmitted = nextEntry.isSubmitted === true || q.isSubmitted === true;
          const editorCode = (isAlreadySubmitted && q.execution?.sourceCode) ? q.execution.sourceCode : (q.defaultCode || "");

          dispatch({
            type: "CODING_NAV_FILL_QUESTION",
            payload: {
              index: currentIndex + 1,
              question: {
                ...q,
                candidateTestDetailId: nextEntry.candidateTestDetailId,
                submitted: isAlreadySubmitted,
                questionOrder: nextEntry.questionOrder,
                currentQuestion: nextEntry.currentQuestion,
                totalQuestion: nextEntry.totalQuestion,
                isPlaceholder: false,
                editorState: {
                  code: editorCode,
                  language: normalizedLanguage,
                },
              },
            },
          });

          if (isAlreadySubmitted && q.candidateQuestionId) {
            starterFetchedRef.current[q.candidateQuestionId] = true;
          }
        }

        setQuestionLoading(false);
      }

      dispatch({ type: "CODING_NAV_NEXT" });
      return;
    }

    questionSourceRef.current = "API";
    setQuestionLoading(true);
    setNextLoading(true);

    const res = await retryOnNetworkFailure(
      () => dispatch(getQuestion(invitationToken, authToken)),
      () => { setQuestionLoading(false); setNextLoading(false); setActive(prevActive); }
    );

    if (!res?.payload) {
      setQuestionLoading(false);
      setNextLoading(false);
      return;
    }

    if (res.payload.isNextTest) {
      dispatch({ type: "CODING_NAV_RESET" });

      if (isExtendedTimerRef.current) {
        isExtendedTimerRef.current = false;
        dispatch(pauseAdditionalDurationTimer(invitationToken, authToken));
        stopExtendedHeartbeat();
      }

      questionSourceRef.current = "API";
      starterFetchedRef.current = {};
      setActive("test-summary");
      setQuestionLoading(false);
      setNextLoading(false);
      return;
    }

    if (res.payload.isTestCompleted) {
      dispatch({ type: "CODING_NAV_RESET" });
      setActive("feedback");
      setQuestionLoading(false);
      setNextLoading(false);
      return;
    }

    const q = res.payload.question;
    if (!q) return;

    const isDatabase = q.questionTypeID === 12;
    const langObj = isDatabase
      ? q.databaseLanguages?.[0]
      : q.languages?.[0];

    const normalizedLanguage = langObj
      ? {
        label: langObj.displayLanguage,
        value: isDatabase
          ? langObj.databaseLanguage
          : langObj.codingLanguage,
      }
      : null;

    const activeTestDetailId = testSummary?.testDetails?.tests?.find((t) => t.candidateTestStatus === 2)?.candidateTestDetailId;

    dispatch({
      type: "CODING_NAV_APPEND",
      payload: {
        ...q,
        candidateTestDetailId: activeTestDetailId,
        submitted: false,
        editorState: {
          code: q.defaultCode || "",
          language: normalizedLanguage,
        },
      },
    });

    setActive("test");
    setQuestionLoading(false);
    setNextLoading(false);
  };

  const getSummary = () => {
    setActive("test-summary");
  };

  const closeWindow = () => {
    try {
      const redirectURL = candidateDetails?.redirectURL || testDetails?.redirectURL;

      localStorage.removeItem('token');
      localStorage.removeItem('profileDetails');
      localStorage.removeItem('email');
      localStorage.removeItem('userId');
      localStorage.removeItem('domainDetails');
      localStorage.removeItem('emailVerified');
      sessionStorage.clear();

      if (redirectURL) {
        window.location.replace(redirectURL);
      } else {
        window.location.replace("/login");
      }
    } catch (error) {
      console.error("Error while clearing session:", error);
      window.location.replace("/login");
    }
  };

  useEffect(() => {
    let captureInterval;

    if (active === "test") {

      const captureDelay = 15000;
      captureInterval = setInterval(() => {
        captureDuringTest();
        setCaptureCount((prevCount) => prevCount + 1);
      }, captureDelay);
    }

    return () => clearInterval(captureInterval);
  }, [active]);

  useEffect(() => {
    if (active !== "test") return;
    const interval = setInterval(() => {
      dispatch(heartbeatAssessmentActivity(invitationToken, authToken));
    }, 15000);
    return () => clearInterval(interval);
  }, [active, authToken, dispatch, invitationToken]);

  const webcamRef3 = useRef(null);
  const streamResumingRef = useRef(false);
  const lastImageFingerprintRef = useRef(null);
  const dupCaptureCountRef = useRef(0);
  const proctorSkipCountRef = useRef(0);


  const onProctorWebcamMedia = () => {
    proctorSkipCountRef.current = 0;
    console.log("[proctoring] webcam stream acquired");
  };

  const onProctorWebcamError = (err) => {
    console.error("[proctoring] webcam error:", err);
    setShowCameraErrorPopup(true);
  };

  // Keep the proctoring webcam technically rendered (NOT visibility:hidden) so the
  // browser keeps decoding frames — a hidden <video> often stalls at
  // videoWidth/Height 0. Just make it visually negligible.
  const proctorWebcamWrapStyle = {
    position: "fixed",
    right: 0,
    bottom: 0,
    width: 2,
    height: 2,
    opacity: 0.01,
    pointerEvents: "none",
    overflow: "hidden",
    zIndex: -1,
  };

  const resumeWebcamStream = async () => {
    if (!webcamRef3.current) return;
    const video = webcamRef3.current.video;
    if (!video) return;

    streamResumingRef.current = true;
    try {
      const stream = video.srcObject;
      const hasEndedTrack =
        stream &&
        stream.getVideoTracks().some((t) => t.readyState === "ended");

      if (hasEndedTrack || !stream) {
        // Re-acquire the camera stream if the browser killed the tracks
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false,
        });
        video.srcObject = newStream;
      }

      if (video.paused) {
        await video.play().catch(() => { });
      }
    } catch (err) {
      // getUserMedia only throws here when the camera itself is unavailable
      // (permission revoked, device taken by another tab/app, or turned off) —
      // this is the one place that means camera access was actually lost.
      console.error("Failed to resume webcam stream:", err);
      setShowCameraErrorPopup(true);
    } finally {
      // Wait 1s for the stream to produce fresh frames before next capture
      setTimeout(() => {
        streamResumingRef.current = false;
      }, 1000);
    }
  };

  // Draw a <video> element's current frame to a canvas and return a JPEG data URL.
  // Returns null when the element has no decoded frame yet (videoWidth/Height 0).
  // Mirrored horizontally to match the setup screenshots (Webcam mirrored={true}).
  const grabFrameFromVideo = (videoEl) => {
    if (!videoEl) return null;
    const w = videoEl.videoWidth;
    const h = videoEl.videoHeight;
    if (!w || !h) return null;
    try {
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;
      ctx.translate(w, 0);
      ctx.scale(-1, 1);
      ctx.drawImage(videoEl, 0, 0, w, h);
      return canvas.toDataURL("image/jpeg", 0.92);
    } catch (err) {
      console.error("[proctoring] frame grab failed:", err);
      return null;
    }
  };

  const captureDuringTest = async () => {
    // Proctoring is off for this assessment — don't upload periodic webcam
    // snapshots (uploadImage testImageType 3). Everything else in the
    // proctoring flow (violation events, summary) is unchanged.
    if (!isProctoringEnabled) return;
    if (streamResumingRef.current) return; // skip while stream is re-initializing

    // The on-screen popup <video> (popupVideoRef) shares the same MediaStream as
    // the hidden <Webcam>, but being visible it actually decodes frames. The
    // hidden Webcam element frequently sits at videoWidth/Height === 0 with a
    // frozen currentTime, so getScreenshot() there returns null or a black frame.
    // Try the popup first, then the hidden video, then react-webcam as a last resort.
    const hiddenVideo = webcamRef3.current?.video || null;
    let imageSrc =
      grabFrameFromVideo(popupVideoRef.current) ||
      grabFrameFromVideo(hiddenVideo) ||
      (webcamRef3.current ? webcamRef3.current.getScreenshot() : null);

    if (!imageSrc) {
      proctorSkipCountRef.current += 1;
      console.warn(
        `[proctoring] no frame available (skip #${proctorSkipCountRef.current}), attempting stream resume`
      );
      resumeWebcamStream();
      return;
    }
    proctorSkipCountRef.current = 0;

    // Duplicate check — skip byte-identical frames, but NEVER skip forever.
    // After 3 consecutive identical frames, upload anyway so proctoring is not
    // left blank for a candidate who simply sits very still.
    const fingerprint = `${imageSrc.length}:${imageSrc.slice(200, 400)}`;
    if (fingerprint === lastImageFingerprintRef.current) {
      dupCaptureCountRef.current += 1;
      if (dupCaptureCountRef.current < 3) {
        resumeWebcamStream();
        return;
      }
    } else {
      dupCaptureCountRef.current = 0;
    }
    lastImageFingerprintRef.current = fingerprint;

    var file = dataURLtoFile(imageSrc, "user.png");
    const data = new FormData();
    data.append("token", invitationToken);
    data.append("file", file);
    const uploadRes = await dispatch(uploadImage(data, 3, token));
    if (!uploadRes) {
      // Upload failure here can just as easily be a dropped internet
      // connection as a real camera problem — don't show the camera
      // popup for it, the next 15s interval will simply retry.
      console.error("Failed to upload proctoring image, will retry next interval");
    }
  };

  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
  };

  const submitFeedback = async () => {
    setLoadingFeedback(true);
    if (rating === 0) {
      setRatingError(t("Please Select rating"));
    } else {
      const obj = {
        candidateTestId: resumeCandidateTestId,
        feebBack: comment,
        rating: rating,
      };
      const res = await dispatch(feedbackSubmited(obj, authToken));
      if (res?.type === "SUBMIT_FEEDBACK") {
        removeScript();
        if (nextStageEventType) {
          if (nextStageEventType === "pre_screening.scheduled" && nextStageLink) {
            navigate(`/pre-screen/${nextStageLink}`);
          } else if (nextStageEventType === "video_interview.scheduled" && nextStageLink) {
            navigate(`/video-call/${nextStageLink}`);
          } else if (nextStageId) {
            navigate(`/hiring-stage/${nextStageId}`);
          } else {
            setActive("test-complete");
          }
        } else {
          setActive("test-complete");
        }
      }
    }
    setLoadingFeedback(false);
  };

  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  useEffect(() => {
    let interval;
    const secRender = async () => {
      if (isRunning && timer > 0) {
        interval = setInterval(() => {
          setTimer(timer - 1);
        }, 1000);
      } else if ((timer === 0 || timer === 1) && active === "test-summary") {
        if (show) return;
        if (!loadingFeedback) {
          await startTest();
        }
        clearInterval(interval);
      }
    };
    secRender();
    return () => clearInterval(interval);
  }, [timer, isRunning]);


  const onUserMediaError = (e) => {
    setIsAllow(true);
  };

  const snackClosed = () => {
    setSuccessMessage(false);
    setSuccessMessageText("");
  };

  const handleFileUpload14 = async (file) => {
    if (!file) return;

    if (!isValidFile(file)) {
      setSuccessMessageText("Invalid file format");
      setSuccessMessage(true);
      return;
    }

    const tempFile = {
      name: file.name,
      url: "",
      isUploading: true,
    };

    setUploadedFile(tempFile);

    try {
      const response = await dispatch(uploadCandidateTestFile(file, token));

      if (response?.url) {
        setUploadedFile({
          name: file.name,
          url: response.url,
          isUploading: false,
        });
      }
    } catch (err) {
      dispatch(
        setSuccessMessage({
          message: "File upload failed",
          severity: "error"
        })
      );
    }
  };

  const downloadFile = async (url, fileName) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      setSuccessMessage(true);
      setSuccessMessageText("Unable to download file");
    }
  };

  const isUploadQ14 = question?.questionTypeID === 14;

  const isNextDisabledForQ14 = isUploadQ14 && (!uploadedFile || uploadedFile?.isUploading);

  const goPrevCodingQues = async (payload) => {
    const { editorState } = payload || {};
    dispatch({
      type: "CODING_NAV_PERSIST_CURRENT",
      payload: { editorState },
    });

    const prevIndex = codingNav.currentIndex - 1;
    const prevEntry = codingNav.history[prevIndex];

    if (prevEntry?.isPlaceholder) {
      setQuestionLoading(true);
      const countInfo = {
        currentQuestion: prevEntry.currentQuestion,
        totalQuestion: prevEntry.totalQuestion,
      };

      const detailRes = await dispatch(
        getQuestionDetail(invitationToken, prevEntry.candidateQuestionId, authToken, countInfo)
      );

      if (detailRes?.payload?.question) {
        const q = detailRes.payload.question;
        const isDatabase = q.questionTypeID === 12;
        const langObj = isDatabase ? q.databaseLanguages?.[0] : q.languages?.[0];
        const normalizedLanguage = langObj
          ? { label: langObj.displayLanguage, value: isDatabase ? langObj.databaseLanguage : langObj.codingLanguage }
          : null;

        const isAlreadySubmitted = prevEntry.isSubmitted === true || q.isSubmitted === true;
        const editorCode = (isAlreadySubmitted && q.execution?.sourceCode) ? q.execution.sourceCode : (q.defaultCode || "");

        dispatch({
          type: "CODING_NAV_FILL_QUESTION",
          payload: {
            index: prevIndex,
            question: {
              ...q,
              candidateTestDetailId: prevEntry.candidateTestDetailId,
              submitted: isAlreadySubmitted,
              questionOrder: prevEntry.questionOrder,
              currentQuestion: prevEntry.currentQuestion,
              totalQuestion: prevEntry.totalQuestion,
              isPlaceholder: false,
              editorState: {
                code: editorCode,
                language: normalizedLanguage,
              },
            },
          },
        });

        if (isAlreadySubmitted && q.candidateQuestionId) {
          starterFetchedRef.current[q.candidateQuestionId] = true;
        }
      }

      setQuestionLoading(false);
    }

    dispatch({ type: "CODING_NAV_PREV" });
  };


  const startPopupDrag = (e) => {
    const div = popupDivRef.current;
    if (!div) return;

    const isTouch = e.type === "touchstart";
    const point = isTouch ? e.touches[0] : e;
    if (!point) return;
    if (!isTouch) e.preventDefault();

    const rect = div.getBoundingClientRect();
    const offsetX = point.clientX - rect.left;
    const offsetY = point.clientY - rect.top;

    const onMove = (ev) => {
      const p = ev.touches ? ev.touches[0] : ev;
      if (!p) return;
      // Stop the page from scrolling while dragging on touch devices.
      if (ev.cancelable) ev.preventDefault();
      const x = Math.max(0, Math.min(p.clientX - offsetX, window.innerWidth - div.offsetWidth));
      const y = Math.max(0, Math.min(p.clientY - offsetY, window.innerHeight - div.offsetHeight));
      div.style.left = x + "px";
      div.style.top = y + "px";
      div.style.right = "auto";
      div.style.bottom = "auto";
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
      window.removeEventListener("touchcancel", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
    window.addEventListener("touchcancel", onUp);
  };

  const openReportModal = () => {
    if (active === "test-summary") setIsRunning(false);
    else if (active === "test") pauseTestTimer();
    setShowReportModal(true);
  };

  const closeReportModal = () => {
    setShowReportModal(false);
    setReportIssueType("");
    setReportDescription("");
    setReportIssueTypeError("");
    setReportDescriptionError("");
    setReportSubmitSuccess(false);
    if (active === "test-summary") setIsRunning(true);
    else if (active === "test") resumeTestTimer();
  };

  const handleReportSubmit = async () => {
    let valid = true;
    if (!reportIssueType) {
      setReportIssueTypeError("Please select an issue type.");
      valid = false;
    }
    if (!reportDescription.trim()) {
      setReportDescriptionError("Please provide details about the issue.");
      valid = false;
    }
    if (!valid) return;

    setReportSubmitting(true);
    await dispatch(reportIssue({
      candidateTestId: resumeCandidateTestId || 0,
      testId: candidateDetails?.testId || 0,
      candidateQuestionId: question?.candidateQuestionId || 0,
      issueType: reportIssueType,
      description: reportDescription,
    }, authToken));
    setReportSubmitting(false);
    setReportSubmitSuccess(true);
    setTimeout(() => {
      closeReportModal();
    }, 900);
  };

  const reportIssueBtn = (
    <button
      onClick={openReportModal}
      style={{
        height: "48px",
        display: "inline-flex",
        alignItems: "center",
        background: "transparent",
        color: "#1b1c1d",
        border: "1px solid #f75891",
        borderRadius: "12px",
        padding: "10px",
        fontFamily: "'inter', sans-serif",
        fontSize: 14,
        fontWeight: 600,
        lineHeight: "24px",
        letterSpacing : "0px",
        textAlign: 'center',
        whiteSpace: "nowrap",
      }}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>&nbsp;
      Report Issue
    </button>
  );

  return (
    <Fragment>
      {!(
        testSummary?.testDetails?.tests?.filter(
          (el) => el.candidateTestStatus === 2
        )[0]?.languageCode === "en" ||
        (show && active === "summary")
      ) && (
          <div className="d-flex justify-content-end">
            <div id="google_translate_element"></div>
          </div>
        )}
      {(nextLoading || wsWaiting) && (
        <div
          className="loading-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.8)",
            zIndex: 900,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="spinner-border"
            role="status"
            style={{ width: "1rem", height: "1rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            minHeight: "100vh",
          }}
        >
          <img src="/images/spinner.svg" alt="" />
        </div>
      ) : !show && isSmallDevice && isProctoringEnabled ? (
        <div className="candidate-holder-sm">
          <p>
            {t(
              "This assessment can only be taken on a laptop or desktop with a minimum screen size of 11.5 inches."
            )}
          </p>
        </div>
      ) : !show ? (
        <div className="candidate-test-holder">
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={successMessage}
            autoHideDuration={3000}
            onClose={snackClosed}
          >
            <Alert
              onClose={snackClosed}
              severity="error"
              sx={{ width: "100%" }}
            >
              {successMessageText}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={isOffline}
            autoHideDuration={null}
          >
            <Alert severity="warning" sx={{ width: "100%" }}>
              Network connection lost. Please check your internet connection.
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={retrySnackbar.open}
            autoHideDuration={null}
          >
            <Alert severity="info" sx={{ width: "100%" }}>
              {retrySnackbar.message}
            </Alert>
          </Snackbar>
          {active === "test" && (
            <>
              {window.innerWidth > 767 ? (
                <Fragment>
                  <div className="candidate-test-header">
                    {window.location.pathname.split("/")[1] ===
                      "candidate-invite-test" ? null : (
                      <div style={question?.questionTypeID === 13 ? { display: 'flex', gap: '7px' } : {}}>
                        <h3 style={{ color: "#000000", marginBottom: '0' }}>
                          {t("Candidate Test Assessment", { ns: "profile" })}
                        </h3>
                        <h3 style={{ color: "#000000" }}>{t("Assessment", { ns: "profile" })}: {testDetails?.testName}</h3>
                      </div>
                    )}
                    {candidateDetails && (
                      <div className="candidate-test-details d-flex align-items-center">
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <h6>
                            {testSummary?.testDetails?.tests
                              ?.find((el) => el.candidateTestStatus === 2)?.testName ||
                              testDetails?.testDetails?.tests?.find(
                                (el) => el.candidateTestStatus === 2
                              )?.testName ||
                              testDetails?.testDetails?.tests?.[0]?.testName ||
                              testDetails?.testName}
                          </h6>&nbsp;&nbsp;
                          <div className="report-issue-wrapper">{reportIssueBtn}</div>
                        </div>
                        <p>
                          <img
                            src="/images/user-icon-wight-fill.svg"
                            alt=""
                            width={24}
                            height={24}
                          />
                          {candidateDetails?.name}
                        </p>
                      </div>
                    )}
                  </div>
                </Fragment>
              ) : (
                <div className="d-flex flex-column candidate-test-header-sm">
                  {window.location.pathname.split("/")[1] ===
                    "candidate-invite-test" ? null : (
                    <h3>{t("Candidate Test Assessment", { ns: "profile" })}</h3>
                  )}
                  {candidateDetails && (
                    <div className="candidate-test-details d-flex align-items-center">
                      <h6>
                        {t("Assessment", { ns: "profile" })}:{" "}
                        {testDetails?.testName}
                      </h6>
                      <p>
                        <img
                          src="/images/user-icon-wight-fill.svg"
                          alt=""
                          width={24}
                          height={24}
                        />
                        {candidateDetails?.name}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
          {active === "summary" ? (
            <Fragment>
              <div className="float-right"></div>

              <div className="candidate-banner">
                <img src="/images/banner.png" alt="" width={"100%"} />
              </div>
              <div className="test-summary">
                {window.innerWidth > 767 && <h3>{t("Assessment Summary")}</h3>}
                <div className="d-flex mt-3">
                  {window.innerWidth > 767 && (
                    <div className="test-list">
                      {testDetails?.testDetails?.tests
                        .sort((a, b) => a.orderId - b.orderId)
                        .map((el) => {
                          return (
                            <div className="list-item">
                              <div>
                                <h4>{el.testName}</h4>
                                <p>
                                  {el.questionCount} {t("Questions")}{" "}
                                  {el.duration} {t("Mins")} | {el.languageCode}
                                </p>
                              </div>
                              {el.candidateTestStatus === 3 ? (
                                <img
                                  src="/images/tick-mark.svg"
                                  alt=""
                                  width={18}
                                />
                              ) : (
                                <img src="/images/grey-tick-mark.svg" alt="" />
                              )}
                            </div>
                          );
                        })}
                      {testDetails?.testDetails?.questions?.length > 0 && (
                        <div className="list-item">
                          <div>
                            <h4>{t("Additional Questions")}</h4>
                            <p>
                              {testDetails?.testDetails?.questions?.length}{" "}
                              {t("Questions")}
                            </p>
                          </div>
                        </div>
                      )}
                      {testDetails?.testDescription !== null && (
                        <div className="mt-5">
                          {window.innerWidth > 767 && <h3>Description </h3>}
                          <p>{testDetails?.testDescription}</p>
                        </div>
                      )}
                    </div>
                  )}

                  {window.innerWidth > 767 && (
                    <div
                      style={{
                        borderLeft: "1px solid #D7DADB",
                        margin: "0px 75px",
                        minHeight: 450,
                      }}
                    ></div>
                  )}
                  <div
                    className="test-list"
                    style={{ width: window.innerWidth > 767 ? "32%" : "100%" }}
                  >
                    <h2>
                      {t("Hi")} {candidateDetails?.name}
                    </h2>
                    <p>
                      {t("Welcome to the assessment for")}{" "}
                      {testDetails?.testName}.
                      {t("Please enter your test code to continue")}
                    </p>
                    {window.innerWidth < 767 &&
                      testDetails?.testDetails?.tests?.length && (
                        <div className="accordion" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                <span className="acc-title">
                                  {t("Assessment Summary")}
                                </span>
                                <span className="acc-sub">
                                  {testDetails?.testDetails?.tests?.length}{" "}
                                  {t("Tests")}, {testDetails?.questionCount}{" "}
                                  {t("Question")}, {testDetails?.duration}{" "}
                                  {t("minutes")}
                                </span>
                              </button>
                            </h2>
                            <div
                              id="collapseOne"
                              className={`accordion-collapse collapse show`}
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <div className="test-list">
                                  {testDetails?.testDetails?.tests.map((el) => {
                                    return (
                                      <div className="list-item">
                                        <div>
                                          <h4>{el.testName}</h4>
                                          <p>
                                            {el.questionCount} {t("Questions")}{" "}
                                            {el.duration} {t("Mins")} |{" "}
                                            {el.languageCode}
                                          </p>
                                        </div>
                                        {el.checked ? (
                                          <img
                                            src="/images/tick-mark.svg"
                                            alt=""
                                            width={18}
                                          />
                                        ) : (
                                          <img
                                            src="/images/grey-tick-mark.svg"
                                            alt=""
                                          />
                                        )}
                                      </div>
                                    );
                                  })}
                                  {testDetails?.testDetails?.questions?.length >
                                    0 && (
                                      <div className="list-item">
                                        <div>
                                          <h4>{t("Additional Questions")}</h4>
                                          <p>
                                            {
                                              testDetails?.testDetails?.questions
                                                ?.length
                                            }{" "}
                                            {t("Questions")}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="candidate-input">
                      {candidateDetails?.name ? null : (
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={name}
                            placeholder="Enter your name"
                            style={{ color: "#fff" }}
                            onChange={(e) => {
                              setName(e.target.value);
                              setNameError("");
                            }}
                          />
                          <small style={{ color: "red" }}>{nameError}</small>
                        </div>
                      )}
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={code}
                          placeholder="Enter Test Code (check invitation email)"
                          style={{ color: "#fff" }}
                          maxLength={6}
                          onChange={(e) => {
                            setCode(e.target.value);
                            setCodeError("");
                          }}
                        />
                        <small style={{ color: "red" }}>{codeError}</small>
                      </div>
                      <div className="d-flex align-items-start mt-4">
                        <input
                          type="checkbox"
                          style={{ width: 27, height: 27 }}
                          onChange={(e) => setChecked(e.target.value)}
                        />
                        &nbsp;
                        <p>
                          {" "}
                          {t(
                            "By taking up this assessment, you are accepting to abide by our"
                          )}{" "}
                          <bold style={{ textDecoration: "underline" }}>
                            {t("Terms & Agreement")}
                          </bold>
                        </p>
                      </div>
                      <button
                        className="form-control mt-2"
                        disabled={name && code && checked ? false : true}
                        style={{
                          background:
                            name && code && checked ? "#F75891" : "grey",
                        }}
                        onClick={() => validate()}
                      >
                        {t("CONTINUE")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ) : active === "diagnostic" ? (
            <div className="diagnostic-holder">
              <div className="diagnostic-text">
                <img src="/images/dignostic.svg" alt="" />
                <h4>{t("Diagnostics")}</h4>
                <p>
                  {t(
                    "Before you being your test, we would like to run a diagnostic test to ensure you are set up correctly. It will only take a couple of minutes"
                  )}
                </p>
              </div>
              <div className="dignostic-check">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button d-flex justify-content-between"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <span>{t("System Check")}</span>
                        {isBrowser && isNetwork && isOs && isScreen ? (
                          <img src="/images/tick-mark.svg" alt="" width={18} />
                        ) : (
                          <img src="/images/error.svg" alt="" />
                        )}
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className={
                        isBrowser && isNetwork && isOs && isScreen
                          ? "accordion-collapse collapse"
                          : "accordion-collapse collapse show"
                      }
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="d-flex flex-wrap">
                          <div className="check-item">
                            <img src="/images/browser-icon.svg" alt="" />
                            <p>{t("Browser")}</p>
                            {window.innerWidth < 767 &&
                              (!isBrowser ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  width={18}
                                  alt=""
                                />
                              ))}
                          </div>
                          <div className="check-item">
                            <img src="/images/os-icon.svg" alt="" />
                            <p>{t("Operating System")}</p>
                            {window.innerWidth < 767 &&
                              (!isOs ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  width={18}
                                  alt=""
                                />
                              ))}
                          </div>
                          <div className="check-item">
                            <img src="/images/resolution.svg" alt="" />
                            <p>{t("Screen Resoultion")}</p>
                            {window.innerWidth < 767 &&
                              (!isScreen ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  alt=""
                                  width={18}
                                />
                              ))}
                          </div>
                          <div className="check-item">
                            <img src="/images/network.svg" alt="" />
                            <p>{t("Network speed")}</p>
                            {window.innerWidth < 767 &&
                              (!isNetwork ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  width={18}
                                  alt=""
                                />
                              ))}
                          </div>
                        </div>
                        {window.innerWidth > 767 && (
                          <div className="d-flex">
                            <div className="check-item no-border">
                              {!isBrowser ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  width={18}
                                  alt=""
                                />
                              )}
                            </div>
                            <div className="check-item no-border">
                              {!isOs ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  width={18}
                                  alt=""
                                />
                              )}
                            </div>
                            <div className="check-item no-border">
                              {!isScreen ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  alt=""
                                  width={18}
                                />
                              )}
                            </div>
                            <div className="check-item no-border">
                              {!isNetwork ? (
                                <img src="/images/error.svg" alt="" />
                              ) : (
                                <img
                                  src="/images/tick-mark.svg"
                                  width={18}
                                  alt=""
                                />
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed d-flex justify-content-between"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <span>{t("Webcam")}</span>
                        {imageSrc ? (
                          <img src="/images/tick-mark.svg" alt="" width={18} />
                        ) : null}
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className={
                        isBrowser && isNetwork && isOs && isScreen
                          ? "accordion-collapse collapse show"
                          : "accordion-collapse collapse"
                      }
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {!imageSrc ? (
                          <Fragment>
                            <div>
                              <Webcam
                                audio={false}
                                height={window.innerWidth > 767 ? 155 : 190}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                width={window.innerWidth > 767 ? 220 : 250}
                                videoConstraints={videoConstraints}
                                style={{
                                  objectFit: "cover",
                                  display: "block",
                                  maxWidth: "100%",
                                }}
                                onUserMediaError={onUserMediaError}
                              />
                            </div>
                          </Fragment>
                        ) : (
                          <img
                            src={imageSrc}
                            alt=""
                            width={window.innerWidth > 767 ? 220 : 250}
                            height={155}
                          />
                        )}
                        {imageSrc ? null : window.innerWidth > 767 ? (
                          <button className="next-btn" onClick={capture}>
                            {t("Capture")}
                          </button>
                        ) : (
                          <div className="mt-2">
                            <button
                              className="next-btn form-control"
                              onClick={capture}
                            >
                              {t("Capture")}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {imageSrc === "" ? null : window.innerWidth > 767 ? (
                  <div className="mt-2">
                    <button
                      className="next-btn"
                      disabled={imageSrc === ""}
                      onClick={imageSrc ? goToIdentity : ""}
                    >
                      {t("NEXT:PHOTO VERIFICATION")}
                    </button>
                  </div>
                ) : (
                  <div className="mt-2 mx-4">
                    <button
                      className="next-btn form-control"
                      disabled={imageSrc === ""}
                      onClick={imageSrc ? goToIdentity : ""}
                    >
                      {t("NEXT:PHOTO VERIFICATION")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          ) : active === "identity" ? (
            <div className="diagnostic-holder">
              <div className="diagnostic-text">
                <img src="/images/identity-icon.svg" alt="" />
                <h4>{t("Photo ID verification")}</h4>
                <p>
                  {t(
                    "Show your ID card in front of the camera and click take photo when the image is clear."
                  )}
                </p>
              </div>
              <div className="dignostic-check text-center">
                <p>{t("Photo Id")}</p>
                {!identity ? (
                  <Fragment>
                    <div>
                      <Webcam
                        audio={false}
                        height={280}
                        ref={webcamRef1}
                        screenshotFormat="image/jpeg"
                        width={window.innerWidth > 767 ? 416 : 332}
                        videoConstraints={videoConstraints1}
                      />
                    </div>
                    {/* <button className='capture-btn'><img src='/images/capture.png' alt='' width={20} /></button> */}
                  </Fragment>
                ) : (
                  <img
                    src={identity}
                    alt=""
                    width={window.innerWidth > 767 ? 416 : 332}
                    height={280}
                  />
                )}
                <div
                  className={
                    window.innerWidth > 767
                      ? "d-flex flex-column align-items-center mt-2"
                      : "text-center mt-2 mx-3"
                  }
                >
                  <button
                    className="next-btn d-flex justify-content-center align-items-center"
                    onClick={captureIdentity}
                  >
                    {"TAKE PHOTO"}
                  </button>
                  <br />
                </div>
              </div>
            </div>
          ) : active === "test-summary" ? (
            loadingFeedback ? (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <img src="/images/spinner.svg" alt="" />
              </div>
            ) : (
              <div className="test-detail-progress">
                <h1>{t("Test Progress and Summary")}</h1>
                <p>
                  {t(
                    "This page will be show you the test progress. You will come here after completing each test"
                  )}{" "}
                </p>
                {window.innerWidth > 767 ? (
                  <div className="d-flex align-items-center justify-content-center flex-wrap">
                    <div className="test-list" style={{ width: "32%" }}>
                      <div className="progress-circular">
                        <CircularProgressbarWithChildren
                          value={testSummary?.completedPercentage}
                          maxValue={100}
                          minValue="0"
                          styles={{
                            root: {
                              width: "100%",
                              fontSize: 10,
                              borderRadius: 150,
                              marginTop: 0,
                              background: "#fff",
                              verticalAlign: "middle",
                              position: "relative",
                            },
                            path: {
                              strokeLinecap: "square",
                              stroke: "#02C573",
                              strokeWidth: 8,
                            },
                            trail: {
                              // Trail color
                              stroke: "#F2f2f3",
                              strokeWidth: 8,
                              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                              strokeLinecap: "round",
                            },
                          }}
                        >
                          <div
                            className="text-center"
                            style={{
                              fontSize: 21,
                              color: "#3d4143",
                              fontFamily: "Poppins",
                            }}
                          >
                            <p
                              className="text-center"
                              style={{
                                fontWeight: 600,
                                fontSize: 48,
                                color: "#3d4143",
                                marginBottom: 40,
                              }}
                            >
                              {testSummary?.completedPercentage + "%"}
                            </p>
                            <hr />
                            <strong className="text-center">
                              {testSummary?.totalCompletedTest}/
                              {testSummary?.totalTest}
                            </strong>
                            <br />
                            <span
                              style={{
                                fontSize: 14,
                                color: "#555C5E",
                                fontFamily: "Poppins",
                              }}
                            >
                              {t("Test Completed")}
                            </span>
                          </div>
                        </CircularProgressbarWithChildren>
                      </div>
                    </div>
                    <div
                      style={{
                        borderLeft: "1px solid #D7DADB",
                        margin: "0px 75px",
                        minHeight: 450,
                      }}
                    ></div>
                    <div className="test-list">
                      {testSummary?.testDetails?.tests
                        .sort((a, b) => a.orderId - b.orderId)
                        .map((el) => {
                          return (
                            <div className="list-item">
                              <div>
                                <h4>{el.testName}</h4>
                                <p>
                                  {el.questionCount} {t("Questions")}{" "}
                                  {el.duration} {t("Mins")} | {el.languageCode}
                                </p>
                              </div>
                              {el.candidateTestStatus === 3 ? (
                                <img
                                  src="/images/tick-mark.svg"
                                  alt=""
                                  width={18}
                                />
                              ) : (
                                <img src="/images/grey-tick-mark.svg" alt="" />
                              )}
                            </div>
                          );
                        })}
                      {testSummary?.testDetails?.questions?.length > 0 && (
                        <div className="list-item">
                          <div>
                            <h4>{t("Additional Questions")}</h4>
                            <p>
                              {testSummary?.testDetails?.questions?.length}{" "}
                              {t("Questions")}
                            </p>
                          </div>
                        </div>
                      )}

                      <div className="next-btns d-flex gap-2">
                        <button
                          className="d-flex align-items-center justify-content-center"
                          onClick={startTest}
                        >
                          <span>{t("Test starts in")}</span> &nbsp;
                          <span className="d-inline-flex align-items-center">
                            <span>{minutes.toString().padStart(2, "0")}</span>:
                            <span>{seconds.toString().padStart(2, "0")}</span>
                          </span>
                        </button>
                        <div>{reportIssueBtn}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="">
                    <div className="mt-3" style={{ marginLeft: 35 }}>
                      <ProgressBar
                        labelColor={"#3D4143"}
                        bgcolor={"#02C573"}
                        fill={"#212425"}
                        completed={testSummary?.completedPercentage}
                      />
                      <div
                        style={{
                          fontSize: 14,
                          marginTop: -25,
                          color: "#555C5E",
                          fontFamily: "Poppins",
                        }}
                      >
                        {testSummary?.totalCompletedTest}/
                        {testSummary?.totalTest}&nbsp;
                        {t("Test Completed")}
                      </div>
                    </div>
                    <div className="test-list">
                      {testSummary?.testDetails?.tests
                        .sort((a, b) => a.orderId - b.orderId)
                        .map((el) => {
                          return (
                            <div className="list-item">
                              <div>
                                <h4>{el.testName}</h4>
                                <p>
                                  {el.questionCount} {t("Questions")}{" "}
                                  {el.duration} {t("Mins")} | {el.languageCode}
                                </p>
                              </div>
                              {el.candidateTestStatus === 3 ? (
                                <img
                                  src="/images/tick-mark.svg"
                                  alt=""
                                  width={18}
                                />
                              ) : (
                                <img src="/images/grey-tick-mark.svg" alt="" />
                              )}
                            </div>
                          );
                        })}
                      {testSummary?.testDetails?.questions?.length > 0 && (
                        <div className="list-item">
                          <div>
                            <h4>{t("Additional Questions")}</h4>
                            <p>
                              {testSummary?.testDetails?.questions?.length}{" "}
                              {t("Questions")}
                            </p>
                          </div>
                        </div>
                      )}

                      <div className="next-btns">
                        {/* <button onClick={() => changeActive('test')}>Next test starts in: 9</button> */}
                        <button onClick={startTest}>
                          {t("Test Starts in")}{" "}
                          <span>
                            {minutes.toString().padStart(2, "0")}:
                            {seconds.toString().padStart(2, "0")}
                          </span>{" "}
                        </button>
                        <div>{reportIssueBtn}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          ) : active === "test" ? (
            loadingFeedback ? (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              >
                <img src="/images/spinner.svg" alt="" />
              </div>
            ) : (
              question !== null &&
              (question?.questionTypeID === 15 ? (
                <Fragment>
                  <div className="timer-div">
                    <div id="revese-timer">
                      <div className="base-timer">
                        <svg className="base-timer__svg" viewBox="0 0 100 80">
                          <g className="base-timer__circle">
                            <circle className="base-timer__path-elapsed" cx="50" cy="40" r="35" />
                            <path
                              id="base-timer-path-remaining"
                              stroke-dasharray="283"
                              className={`base-timer__path-remaining ${remainingPathColor}`}
                              d="M 50, 40
                                m -35, 0
                                a 35,35 0 1,0 70,0
                                a 35,35 0 1,0 -70,0"
                            />
                          </g>
                        </svg>
                        <span id="base-timer-label" className="base-timer__label">
                          {formatTime(timeLeftRef.current)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <TypingTestPlayer
                    question={question}
                    onProgress={(payload) => { typingResultRef.current = payload; }}
                    onSubmit={async (payload) => {
                      typingResultRef.current = payload;
                      await getNext();
                      return typingSubmitOkRef.current;
                    }}
                  />
                  {
                    <div style={proctorWebcamWrapStyle}>
                      {
                        <Webcam
                          style={{
                            width: "100%",
                            height: 250,
                            display: "block",
                          }}
                          audio={false}
                          ref={webcamRef3}
                          screenshotFormat="image/jpeg"
                          onUserMedia={onProctorWebcamMedia}
                          onUserMediaError={onProctorWebcamError}
                          mirrored={true}
                          imageSmoothing={true}
                          screenshotQuality={1}
                        />
                      }
                    </div>
                  }
                </Fragment>
              ) : (question?.questionTypeID === 7 || (question?.questionTypeID === 12 && question?.referenceTypeId !== 6) || question?.questionTypeID === 13) ? (
                <Fragment>
                  <div className="timer-div">
                    <div id="revese-timer">
                      <div className="base-timer">
                        <svg className="base-timer__svg" viewBox="0 0 100 80">
                          <g className="base-timer__circle">
                            <circle className="base-timer__path-elapsed" cx="50" cy="40" r="35" />
                            <path
                              id="base-timer-path-remaining"
                              stroke-dasharray="283"
                              className={`base-timer__path-remaining ${remainingPathColor}`}
                              d="M 50, 40
                                m -35, 0
                                a 35,35 0 1,0 70,0
                                a 35,35 0 1,0 -70,0"
                            />
                          </g>
                        </svg>
                        <span id="base-timer-label" className="base-timer__label">
                          {formatTime(timeLeftRef.current)}
                        </span>
                      </div>
                    </div>
                  </div>
                  {active === "test" && (isCodingOrDb || isJupyter) && (
                    questionLoading || (!activeQuestion?.editorState && !isJupyter)
                      ? (
                        <div
                          className="loading-overlay"
                          style={{
                            width: "100%",
                            height: "73vh",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#fff",
                            zIndex: 20,
                          }}
                        >
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ width: "1rem", height: "1rem" }}
                          >
                            <span className="visually-hidden">Loading question...</span>
                          </div>
                        </div>
                      )
                      : (
                        <Main
                          question={activeQuestion}
                          codingNav={codingNav}
                          onPrev={goPrevCodingQues}
                          onNext={getNextCodingQues}
                          getNext={getNextCodingQues}
                          isNextTest={isNextTest}
                          isTestCompleted={isTestCompleted}
                          getSummary={getSummary}
                          token={token}
                          inviteToken={invitationToken}
                          setActive={() => setActive("feedback")}
                          startTimer={startTimer}
                          pauseTestTimer={pauseTestTimer}
                          resumeTestTimer={resumeTestTimer}
                          uploadImage={(data) =>
                            isProctoringEnabled
                              ? dispatch(uploadImage(data, 3, token))
                              : Promise.resolve()
                          }
                          onCodeChange={(editorState) => {
                            currentEditorStateRef.current = editorState;
                            dispatch({
                              type: "CODING_NAV_PERSIST_CURRENT",
                              payload: { editorState },
                            });
                          }}
                          onBeforeTestCompleted={async () => {
                            if (isExtendedTimerRef.current) {
                              isExtendedTimerRef.current = false;
                              dispatch(pauseAdditionalDurationTimer(invitationToken, authToken));
                              stopExtendedHeartbeat();
                            }
                          }}
                          onTestCompleted={async () => {
                            setQuestionLoading(true);
                            setLoadingFeedback(true);
                            dispatch({ type: "CODING_NAV_RESET" });

                            const summaryRes = await dispatch(getTestSummary(resumeCandidateTestId, authToken));
                            // Status 1 = not started, 2 = in progress, 3 = completed. The next
                            // test is still status 1 here (it only flips to 2 once startTest
                            // fetches its first question), so check both.
                            const hasMoreTests = summaryRes?.payload?.testDetails?.tests?.some(
                              (t) => t.candidateTestStatus === 1 || t.candidateTestStatus === 2
                            );

                            if (!hasMoreTests) {
                              // No test is pending or in progress — this was the last test in the
                              // assessment. Go straight to the feedback flow instead of always
                              // bouncing through the "next test starts in" screen, which used to
                              // show even when there was no next test to start.
                              // NOTE: getQuestion has a server-side side effect (it serves the
                              // next question), so it must never be called while another test
                              // is still pending — otherwise its first question gets skipped.
                              const qRes = await dispatch(getQuestion(invitationToken, authToken));
                              if (qRes?.payload?.isTestCompleted) {
                                clearInterval(timerIntervalRef.current);
                                timerIntervalRef.current = null;
                                timeLeftRef.current = 0;
                                await dispatch(getTestSummary(resumeCandidateTestId, authToken));
                                setQuestionLoading(false);
                                setActive("feedback");
                                setLoadingFeedback(false);
                                return;
                              }
                            }

                            setTimer(10);
                            setIsRunning(true);
                            setQuestionLoading(false);
                            setActive("test-summary");
                            setLoadingFeedback(false);
                          }}
                        />
                      )
                  )}
                  {
                    <div style={proctorWebcamWrapStyle}>
                      {
                        <Webcam
                          style={{
                            width: "100%",
                            height: 250,
                            display: "block",
                          }}
                          audio={false}
                          ref={webcamRef3}
                          screenshotFormat="image/jpeg"
                          onUserMedia={onProctorWebcamMedia}
                          onUserMediaError={onProctorWebcamError}
                          mirrored={true}
                          imageSmoothing={true}
                          screenshotQuality={1}
                        />
                      }
                    </div>
                  }
                </Fragment>
              ) : question?.questionTypeID === 8 ||
                question?.questionTypeID === 11 ? (
                <div className="test-view">
                  <div className="timer-div">
                    <div id="revese-timer">
                      <div className="base-timer">
                        <svg
                          className="base-timer__svg"
                          viewBox="0 0 100 80"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g className="base-timer__circle">
                            <circle
                              className="base-timer__path-elapsed"
                              cx="50"
                              cy="40"
                              r="35"
                            ></circle>
                            <path
                              id="base-timer-path-remaining"
                              stroke-dasharray="283"
                              className={`base-timer__path-remaining ${remainingPathColor}`}
                              d="M 50, 40
                                                                                       m -35, 0
                                                                                       a 35,35 0 1,0 70,0
                                                                                       a 35,35 0 1,0 -70,0
                                                                                       "
                            ></path>
                          </g>
                        </svg>
                        <span
                          id="base-timer-label"
                          className="notranslate base-timer__label"
                        >
                          {formatTime(timeLeftRef.current)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <Fragment>
                    {
                      <div
                        className="row"
                        style={{
                          minHeight: window.innerWidth > 767 ? 280 : "",
                        }}
                      >
                        <div className="col-md-6">
                          <div className="d-flex align-items-center">
                            <h5 key={question?.candidateQuestionId}>
                              {question?.currentQuestion}/
                              {question?.totalQuestion}
                            </h5>
                            <p className="test-type">
                              {question?.questionTypeID === 1
                                ? "MCQ"
                                : question?.questionTypeID === 8
                                  ? "Big Five"
                                  : question?.questionTypeID === 11
                                    ? "Rating"
                                    : question?.questionTypeID === 14
                                      ? "File Based"
                                      : question?.questionTypeID === 16
                                        ? "DISC test"
                                        : "Essay"}
                            </p>
                          </div>
                          <div className="mt-3">
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: question?.question,
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={
                            window.innerWidth > 767
                              ? "col-md-6"
                              : "col-md-6 mt-5"
                          }
                        >
                          <div className="d-flex flex-column align-items-start">
                            {emojis.map((el, i) => {
                              const optionText =
                                question?.questionTypeID === 11
                                  ? question?.questionOptions?.[i]
                                    ?.questionOption
                                  : el.text;

                              return (
                                <div
                                  key={el.id}
                                  className={
                                    activeEmoji === el.id
                                      ? "question-option active"
                                      : "question-option"
                                  }
                                  onClick={() => {
                                    setActiveEmoji(el.id);
                                    setQid(question.candidateQuestionId);
                                  }}
                                >
                                  <img src={el.emoji} alt="" width={40} />
                                  <span
                                    style={{
                                      fontWeight:
                                        activeEmoji === el.id ? 700 : 400,
                                    }}
                                  >
                                    &nbsp;{optionText}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    }
                    <hr
                      style={{
                        height: "2px",
                        color: "#E4E9F0",
                        background: "#E4E9F0",
                      }}
                    />
                    <div className="text-right">
                      <button
                        className="next-btn"
                        disabled={
                          (
                            isFileUploadQ14
                              ? isNextDisabledForQ14
                              : !isJupyter && (
                                (!option && !activeEmoji && !answerText) ||
                                (question?.shouldProvideReason === 1 && reason.trim() === "")
                              )
                          ) || nextLoading
                        }
                        style={{
                          background: (
                            isFileUploadQ14
                              ? isNextDisabledForQ14
                              : !isJupyter && (
                                (!option && !activeEmoji && !answerText) ||
                                (question?.shouldProvideReason === 1 && reason.trim() === "")
                              )
                          ) ? "#8A9199 !important" : "",
                          border: (
                            isFileUploadQ14
                              ? isNextDisabledForQ14
                              : !isJupyter && (
                                (!option && !activeEmoji && !answerText) ||
                                (question?.shouldProvideReason === 1 && reason.trim() === "")
                              )
                          ) ? "none !important" : "none",
                          color: "#FFFFFF",
                          opacity: (
                            isFileUploadQ14
                              ? isNextDisabledForQ14
                              : !isJupyter && (
                                (!option && !activeEmoji && !answerText) ||
                                (question?.shouldProvideReason === 1 && reason.trim() === "")
                              )
                          ) ? "0.6" : "1",
                          cursor: (
                            isFileUploadQ14
                              ? isNextDisabledForQ14
                              : !isJupyter && (
                                (!option && !activeEmoji && !answerText) ||
                                (question?.shouldProvideReason === 1 && reason.trim() === "")
                              )
                          ) ? "not-allowed" : "pointer",
                        }}
                        onClick={() =>
                          !isNextTest && !isTestCompleted
                            ? getNext()
                            : isTestCompleted
                              ? setActive("feedback")
                              : isNextTest
                                ? getSummary()
                                : null
                        }
                      >
                        {t("Next")}
                      </button>
                    </div>
                  </Fragment>

                  {
                    <div style={proctorWebcamWrapStyle}>
                      {
                        <Webcam
                          style={{
                            width: "100%",
                            height: 250,
                            display: "block",
                          }}
                          audio={false}
                          ref={webcamRef3}
                          screenshotFormat="image/jpeg"
                          onUserMedia={onProctorWebcamMedia}
                          onUserMediaError={onProctorWebcamError}
                          mirrored={true}
                          imageSmoothing={true}
                          screenshotQuality={1}
                        />
                      }
                    </div>
                  }
                </div>
              ) : question?.questionTypeID === 5 ? (
                <div className="test-view">
                  <div className="timer-div">
                    <div id="revese-timer">
                      <div className="base-timer">
                        <svg
                          className="base-timer__svg"
                          viewBox="0 0 100 80"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g className="base-timer__circle">
                            <circle
                              className="base-timer__path-elapsed"
                              cx="50"
                              cy="40"
                              r="35"
                            ></circle>
                            <path
                              id="base-timer-path-remaining"
                              stroke-dasharray="283"
                              className={`base-timer__path-remaining ${remainingPathColor}`}
                              d="
                        M 50, 40
                        m -35, 0
                        a 35,35 0 1,0 70,0
                        a 35,35 0 1,0 -70,0
                    "
                            ></path>
                          </g>
                        </svg>
                        <span
                          id="base-timer-label"
                          className="notranslate base-timer__label"
                        >
                          {formatTime(timeLeftRef.current)}
                        </span>
                      </div>
                    </div>
                  </div>
                  {
                    <Fragment>
                      {
                        <div
                          className="row"
                          style={{
                            minHeight: window.innerWidth > 767 ? 280 : "",
                          }}
                        >
                          <div className="col-md-6">
                            <div className="d-flex align-items-center">
                              <h5 key={question?.candidateQuestionId}>
                                {question?.currentQuestion}/
                                {question?.totalQuestion}
                              </h5>
                              <p className="test-type">
                                {question?.questionTypeID === 1
                                  ? "MCQ"
                                  : question?.questionTypeID === 9
                                    ? "MBTI"
                                    : question?.questionTypeID === 11
                                      ? "Rating"
                                      : question?.questionTypeID === 14
                                        ? "File Based"
                                        : question?.questionTypeID === 16
                                          ? "DISC test"
                                          : "Essay"}
                              </p>
                            </div>
                            <div className="mt-3">
                              <h3
                                dangerouslySetInnerHTML={{
                                  __html: question.question,
                                }}
                              />
                            </div>
                          </div>
                          <div
                            className={
                              window.innerWidth > 767
                                ? "col-md-12 mt-3"
                                : "col-md-12 mt-3"
                            }
                          >
                            <textarea
                              rows={8}
                              cols={4}
                              className="form-control"
                              value={answerText}
                              onChange={(e) => setAnswerText(e.target.value)}
                              placeholder="Add Your answer here"
                            />
                          </div>
                        </div>
                      }
                      <hr
                        style={{
                          height: "2px",
                          color: "#E4E9F0",
                          background: "#E4E9F0",
                        }}
                      />
                      <div className="text-right">
                        <button
                          className="next-btn"
                          disabled={
                            (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) || nextLoading
                          }
                          style={{
                            background: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "#8A9199 !important" : "",
                            border: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "none !important" : "none",
                            color: "#FFFFFF",
                            opacity: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "0.6" : "1",
                            cursor: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "not-allowed" : "pointer",
                          }}
                          onClick={() =>
                            !isNextTest && !isTestCompleted
                              ? getNext()
                              : isTestCompleted
                                ? setActive("feedback")
                                : isNextTest
                                  ? getSummary()
                                  : null
                          }
                        >
                          {t("Next")}
                        </button>
                      </div>
                    </Fragment>
                  }
                  {
                    <div style={proctorWebcamWrapStyle}>
                      {
                        <Webcam
                          style={{
                            width: "100%",
                            height: 250,
                            display: "block",
                          }}
                          audio={false}
                          ref={webcamRef3}
                          screenshotFormat="image/jpeg"
                          onUserMedia={onProctorWebcamMedia}
                          onUserMediaError={onProctorWebcamError}
                          mirrored={true}
                          imageSmoothing={true}
                          screenshotQuality={1}
                        />
                      }
                    </div>
                  }
                </div>
              ) : (
                <div className="test-view">
                  <div className="timer-div">
                    <div id="revese-timer">
                      <div className="base-timer">
                        <svg
                          className="base-timer__svg"
                          viewBox="0 0 100 80"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g className="base-timer__circle">
                            <circle
                              className="base-timer__path-elapsed"
                              cx="50"
                              cy="40"
                              r="35"
                            ></circle>
                            <path
                              id="base-timer-path-remaining"
                              stroke-dasharray="283"
                              className={`base-timer__path-remaining ${remainingPathColor}`}
                              d="
                        M 50, 40
                        m -35, 0
                        a 35,35 0 1,0 70,0
                        a 35,35 0 1,0 -70,0
                    "
                            ></path>
                          </g>
                        </svg>
                        <span
                          id="base-timer-label"
                          className="notranslate base-timer__label"
                        >
                          {formatTime(timeLeftRef.current)}
                        </span>
                      </div>
                    </div>
                  </div>
                  {
                    <Fragment>
                      {
                        <div
                          className="row"
                          style={{
                            minHeight: window.innerWidth > 767 ? 280 : "",
                          }}
                        >
                          <div className={question?.questionTypeID === 14 ? "" : "col-md-6"}>
                            <div className="d-flex align-items-center">
                              <div className="d-flex align-items-center">
                                <h5 key={question?.candidateQuestionId}>
                                  {question?.currentQuestion}/
                                  {question?.totalQuestion}
                                </h5>
                              </div>
                              <p className="test-type">
                                {question?.questionTypeID === 1
                                  ? "MCQ"
                                  : question?.questionTypeID === 9
                                    ? "MBTI"
                                    : question?.questionTypeID === 11
                                      ? "Rating"
                                      : question?.questionTypeID === 14
                                        ? "File Based"
                                        : question?.questionTypeID === 16
                                          ? "DISC test"
                                          : "Essay"}
                              </p>
                            </div>
                            <div className="mt-3">
                              <h3
                                dangerouslySetInnerHTML={{
                                  __html: question?.question,
                                }}
                              />
                            </div>
                          </div>
                          {question?.questionTypeID === 5 ? (
                            <div
                              className={
                                window.innerWidth > 767
                                  ? "col-md-6 mt-3"
                                  : "col-md-6 mt-3"
                              }
                            >
                              <textarea
                                rows={4}
                                cols={4}
                                className="form-control"
                                value={answerText}
                                onChange={(e) => setAnswerText(e.target.value)}
                              />
                            </div>
                          ) : question?.questionTypeID === 14 ? (
                            <div className="question-type-14">
                              {parsedQuestionData?.files?.length > 0 && (
                                <>
                                  <label className="mb-2 d-block" style={{ color: "#F75891" }}>Added files</label>
                                  <div className="row mt-2 mb-2 mx-0 my-0">
                                    <div className="dataset-label col-md-12 col-12" style={{ padding: '10px 0' }}>
                                      <p>Here you can download the question and work on it</p>
                                    </div>
                                    {parsedQuestionData.files.map((file, index) => (
                                      <div key={index} className="dataset-row col-md-6 col-12" style={{ paddingLeft: '0' }}>
                                        <div className="file-chip d-flex align-items-center justify-content-between mb-3" style={{ background: '#9E9E9E3A', padding: '8px', borderRadius: '4px' }}>
                                          <span>{file.name}</span>
                                          &nbsp;&nbsp;
                                          <img
                                            src="/images/download-pink.svg"
                                            alt="download"
                                            onClick={() => downloadFile(file.url, file.name)}
                                            style={{ cursor: "pointer" }}
                                            width={20} height={20}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}
                              <label className="mt-3 d-block" style={{ color: "#F75891" }}>
                                Add File
                              </label>

                              {!uploadedFile ? (
                                <div className="dataset-row d-flex justify-content-between" style={{ marginBottom: '10px' }}>
                                  <div className="dataset-label" style={{ padding: '10px 0' }}>
                                    Here by clicking upload file you can submit your answer
                                  </div>
                                  <div>
                                    <input
                                      type="file"
                                      hidden
                                      id="uploadFile14"
                                      accept=".zip"
                                      onChange={(e) => handleFileUpload14(e.target.files[0])}
                                    />

                                    <label htmlFor="uploadFile14" className="cursor-pointer file-upload">
                                      {uploading ? (
                                        <Spinner size="sm" />
                                      ) : (
                                        "UPLOAD FILE"
                                      )}
                                    </label>
                                  </div>
                                </div>
                              ) : (
                                <div className="row mt-2 mb-2 mx-0 my-0">
                                  <div className="col-md-12 col-12" style={{ padding: '10px 0' }}>
                                    <p>This File upload submition of answer to the question</p>
                                  </div>
                                  <div className="file-chip col-md-6 col-12" style={{ paddingLeft: '0' }}>
                                    <div className="d-flex align-items-center justify-content-between mb-3" style={{ background: '#9E9E9E3A', padding: '8px', borderRadius: '4px' }}>
                                      <span>{uploadedFile.name}</span>&nbsp;&nbsp;
                                      {uploadedFile?.isUploading ? (
                                        <Spinner
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          className="text-danger"
                                        />
                                      ) : (
                                        <img
                                          src="/images/delete-red.svg"
                                          alt="delete"
                                          className="cursor-pointer"
                                          onClick={() => setUploadedFile(null)}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div
                              className={
                                window.innerWidth > 767
                                  ? "col-md-6"
                                  : "col-md-6 mt-3"
                              }
                            >
                              <div className="d-flex flex-column align-items-end">
                                {question?.questionOptions?.map((el, i) => {
                                  return (
                                    <div
                                      key={el.questionOptionID}
                                      className={
                                        option === el.questionOptionID
                                          ? "ques-option select-option cursor-pointer"
                                          : "ques-option cursor-pointer"
                                      }
                                      onClick={() =>
                                        selectOption(
                                          el.questionOptionID,
                                          question.candidateQuestionId
                                        )
                                      }
                                    >
                                      <div className="d-flex align-items-center">
                                        <strong className="question-index">
                                          <span className="notranslate">
                                            {i === 0
                                              ? "A"
                                              : i === 1
                                                ? "B"
                                                : i === 2
                                                  ? "C"
                                                  : i === 3
                                                    ? "D"
                                                    : i === 4
                                                      ? "E"
                                                      : i === 5
                                                        ? "F"
                                                        : i === 6
                                                          ? "G"
                                                          : "H"}
                                          </span>
                                        </strong>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: el.questionOption,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              {question?.shouldProvideReason === 1 &&
                                (option || activeEmoji) && (
                                  <div className="ques-description form-group mt-3">
                                    <label>
                                      Please proved justifcation for the
                                      selected choice
                                    </label>
                                    <textarea
                                      rows={5}
                                      className="form-control"
                                      value={reason}
                                      onChange={(e) =>
                                        setReason(e.target.value)
                                      }
                                      placeholder="Enter your justification here"
                                    />
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      }
                      <hr
                        style={{
                          height: "2px",
                          color: "#E4E9F0",
                          background: "#E4E9F0",
                        }}
                      />
                      <div className="text-right">
                        <button
                          className="next-btn"
                          disabled={
                            (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) || nextLoading
                          }
                          style={{
                            background: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "#8A9199 !important" : "",
                            border: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "none !important" : "none",
                            color: "#FFFFFF",
                            opacity: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "0.6" : "1",
                            cursor: (
                              isFileUploadQ14
                                ? isNextDisabledForQ14
                                : !isJupyter && (
                                  (!option && !activeEmoji && !answerText) ||
                                  (question?.shouldProvideReason === 1 && reason.trim() === "")
                                )
                            ) ? "not-allowed" : "pointer",
                          }}
                          onClick={() =>
                            !isNextTest && !isTestCompleted
                              ? getNext()
                              : isTestCompleted
                                ? setActive("feedback")
                                : isNextTest
                                  ? getSummary()
                                  : null
                          }
                        >
                          {t("Next")}
                        </button>
                      </div>
                    </Fragment>
                  }
                  {
                    <div style={proctorWebcamWrapStyle}>
                      {
                        <Webcam
                          style={{
                            width: "100%",
                            height: 250,
                            display: "block",
                          }}
                          audio={false}
                          ref={webcamRef3}
                          screenshotFormat="image/jpeg"
                          onUserMedia={onProctorWebcamMedia}
                          onUserMediaError={onProctorWebcamError}
                          mirrored={true}
                          imageSmoothing={true}
                          screenshotQuality={1}
                        />
                      }
                    </div>
                  }
                </div>
              ))
            )
          ) : active === "feedback" ? (
            loadingFeedback ? (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              >
                <img src="/images/spinner.svg" alt="" />
              </div>
            ) : processingState === "done" ? (
              <div className="thank-you-screen">
                <h2>{t("Assessment Completed")}</h2>
                <p>{t("You will receive an email notification for the next steps")}</p>
                <div className="d-flex justify-content-center">
                  <button className="next-btn mt-3" onClick={closeWindow}>{t("Close Window")}</button>
                </div>
              </div>
            ) : (
              <div className="test-detail-progress">
                <div className="text-center">
                  <img src="/images/tick-mark.svg" alt="" />
                </div>
                <h1 className="mt-3">{t("Assessment Completed")}</h1>
                <div
                  className={
                    window.innerWidth > 767
                      ? "d-flex  justify-content-center flex-wrap mt-4"
                      : "d-flex flex-wrap mt-4"
                  }
                >
                  <div
                    className="test-list"
                    style={{ width: window.innerWidth > 767 ? "48%" : "100%" }}
                  >
                    {testSummary?.testDetails?.tests
                      .sort((a, b) => a.orderId - b.orderId)
                      .map((el) => {
                        return (
                          <div className="list-item">
                            <div>
                              <h4>{el.testName}</h4>
                              <p>
                                {el.questionCount} {t("Questions")}{" "}
                                {el.duration} {t("Mins")}
                              </p>
                            </div>
                            {el.candidateTestStatus === 3 ? (
                              <img
                                src="/images/tick-mark.svg"
                                alt=""
                                width={18}
                              />
                            ) : (
                              <img src="/images/grey-tick-mark.svg" alt="" />
                            )}
                          </div>
                        );
                      })}
                    {testSummary?.testDetails?.questions?.length > 0 && (
                      <div className="list-item">
                        <div>
                          <h4>{t("Additional Questions")}</h4>
                          <p>
                            {testSummary?.testDetails?.questions?.length}{" "}
                            {t("Questions")}
                          </p>
                        </div>
                      </div>
                    )}
                    <div className="mt-2">{reportIssueBtn}</div>
                  </div>
                  {window.innerWidth > 767 && (
                    <div
                      style={{
                        borderLeft: "1px solid #D7DADB",
                        margin: "0px 25px",
                        minHeight: 450,
                      }}
                    ></div>
                  )}
                  <div
                    className="test-list feedback-col"
                    style={{ width: window.innerWidth > 767 ? "30%" : "100%" }}
                  >
                    <p>
                      {t(
                        "Thank you for completing the assessment. We will get in touch with you about next steps shortly. Please take a moment to share your assessment experience with us"
                      )}
                    </p>
                    <div
                      style={{
                        padding: window.innerWidth > 767 ? "" : "5px 0",
                      }}
                    >
                      <label>{t("Overall rating")} </label>
                      <div className="d-flex mt-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <Fragment>
                            <StarIcon
                              key={star}
                              filled={star <= rating}
                              onClick={() => handleStarClick(star)}
                            />
                            &nbsp;&nbsp;
                          </Fragment>
                        ))}
                      </div>
                    </div>
                    <div
                      className="form-group mt-3"
                      style={{
                        padding: window.innerWidth > 767 ? "" : "5px 0",
                      }}
                    >
                      <label>{t("Comments if any")} </label>
                      <textarea
                        rows={3}
                        className="form-control mt-2"
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </div>
                    {processingState === "evaluating" && (
                      <div className="d-flex align-items-center mt-3" style={{ gap: "10px", padding: window.innerWidth > 767 ? "" : "5px 0" }}>
                        <div className="spinner-border spinner-border-sm" role="status" style={{ color: "#F75891" }}>
                          <span className="visually-hidden">Evaluating...</span>
                        </div>
                        <span style={{ color: "#F75891", fontSize: "14px" }}>Evaluating your responses...</span>
                      </div>
                    )}
                    {processingState === "eligible" && (
                      <div className="mt-3" style={{ padding: window.innerWidth > 767 ? "" : "5px 0" }}>
                        <p className="evaluation-message" style={{ marginBottom: 0 }}>{evaluationMessage || 'You are eligible for next stage please click on continue to start'}</p>
                      </div>
                    )}
                    {window.innerWidth > 767 ? (
                      <button
                        className="next-btn mt-3"
                        disabled={rating === 0 || processingState === "evaluating"}
                        style={{
                          background: rating === 0 || processingState === "evaluating" ? "grey" : "#F75891",
                          color: rating === 0 || processingState === "evaluating" ? "#000000" : "#FFFFFF",
                        }}
                        onClick={() => submitFeedback()}
                      >
                        {processingState === "eligible" || nextStageEventType ? t("Continue") : t("Submit")}
                      </button>
                    ) : (
                      <div className="text-center mb-3">
                        <button
                          className="next-btn mt-3"
                          disabled={rating === 0 || processingState === "evaluating"}
                          style={{
                            background: rating === 0 || processingState === "evaluating" ? "grey" : "#F75891",
                            color: rating === 0 || processingState === "evaluating" ? "#000000" : "#FFFFFF",
                          }}
                          onClick={() => submitFeedback()}
                        >
                          {processingState === "eligible" || nextStageEventType ? t("Continue") : t("Submit")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          ) : active === "test-complete" ? (
            <div
              className="test-detail-progress text-center"
              style={{ padding: "125px 30px" }}
            >
              <div className="text-center">
                <img src="/images/tick-mark.svg" alt="" />
              </div>
              {window.innerWidth > 767 ? (
                <h1 className="mt-3">{t("Assessment Completed")}</h1>
              ) : (
                <h1 className="mt-3 text-center">{t("Thank you")}</h1>
              )}
              <div className="d-flex  justify-content-center flex-wrap mt-2">
                <div
                  className="test-list "
                  style={{ width: window.innerWidth > 767 ? "70%" : "100%" }}
                >
                  <img src="/images/tick.svg" alt="" />
                  <p className="text-center">
                    {t("You can now close the browser window and exit")}
                  </p>

                  <button className="next-btn mt-3" onClick={closeWindow}>
                    {t("Close Window")}
                  </button>
                </div>
              </div>
            </div>
          ) : null}

          {active === "test" && isProctoringEnabled && (
            <div
              ref={popupDivRef}
              onMouseDown={startPopupDrag}
              onTouchStart={startPopupDrag}
              style={{
                position: "fixed",
                // On mobile, sit clear of the bottom action bar (Next button)
                // and the top timer; the candidate can still drag it anywhere.
                bottom: window.innerWidth > 767 ? 20 : 88,
                left: window.innerWidth > 767 ? 20 : "auto",
                right: window.innerWidth > 767 ? "auto" : 8,
                width: window.innerWidth > 767 ? 160 : 104,
                height: window.innerWidth > 767 ? 120 : 78,
                borderRadius: 8,
                overflow: "hidden",
                boxShadow: "0 4px 16px rgba(0,0,0,0.45)",
                zIndex: 1000,
                cursor: "grab",
                border: "2px solid #f75891",
                background: "#111",
                userSelect: "none",
                touchAction: "none",
              }}
            >
              <video
                ref={popupVideoRef}
                autoPlay
                muted
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transform: "scaleX(-1)",
                  display: "block",
                  pointerEvents: "none",
                }}
              />
            </div>
          )}

          {/* Create custom test modal */}
          <Modal
            show={active === "summary" && isCookie}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName={"cookie-modal"}
          >
            <Modal.Body>
              <div className="mb-2">
                <img src="/images/cookie-icon.svg" alt="" />
              </div>
              <p>
                {t(
                  "We require that you enable cookies for us to provide an optimum assessment experience"
                )}
              </p>
              <div className="mt-2">
                <button
                  onClick={() => {
                    sessionStorage.setItem("token", token);
                    setIsCookie(false);
                  }}
                >
                  {t("ACCEPT ALL COOKIES")}
                </button>
                <button
                  onClick={() => setIsCookie(false)}
                  style={{ fontSize: "10px" }}
                >
                  {t("ACCEPT REQUIRED COOKIES")}
                </button>
                <button onClick={() => setIsCookie(false)}>
                  {t("DECLINE COOKIES")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={isAlert}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName={"warning-modal"}
          >
            <Modal.Body>
              <div className="text-center p-2">
                <img src="/images/alert.png" alt="" width={50} />
                <h3 className="mt-2">{t("Remainder: 2 Minutes left!")}</h3>
                <p className="mt-2">
                  {t(
                    "You have 2 minutes left to complete the test. Please ensure all questions are answered"
                  )}
                  .
                </p>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <div style={{ background: "#fff", width: "100%", height: "60vh" }}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <h1>{message}</h1>
          </div>
        </div>
      )}

      <Modal
        show={isConfirm}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // onHide={this.handleCloseModal}
        dialogClassName={"confirm-modal "}
      >
        <div className="p-4">
          <h1>
            {t(
              "Have you taken your photo correctly? Would you like to proceed or retake it"
            )}{" "}
            ?
          </h1>
          <div className="save-btn">
            <button onClick={goAhead}>{t("Proceed")}</button>&nbsp;&nbsp;
            <button
              onClick={() => {
                setIsConfirm(false);
                reCapture();
              }}
            >
              {t("Retake Photo")}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        show={isAllow && isProctoringEnabled}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // onHide={this.handleCloseModal}
        dialogClassName={"confirm-modal"}
      >
        <div className="p-3 text-center">
          <Fragment>
            <h1 style={{ fontSize: 18 }}>
              You have permission denied for the webcam. Please allow the webcam
              from the browser settings and reload the page.
              {error ? error : ""}
            </h1>
            <div className="save-btn">
              <button
                style={{ width: 112 }}
                onClick={() => {
                  window.location.reload(false);
                  setIsAllow(false);
                }}
              >
                Reload Now
              </button>
            </div>
          </Fragment>
        </div>
      </Modal>
      <Modal
        show={showFullscreenPopup}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="fullscreen-warning-modal"
      >
        <Modal.Body className="text-center p-4">
          <h3 style={{ fontWeight: "600", color: "#333" }}>
            Full screen mode is required
          </h3>
          <hr />
          {fullscreenPopupStep === 1 ? (
            <>
              <p style={{ fontSize: 16, color: "#555" }}>
                This test must be taken in full-screen mode.
              </p>
              <div style={{ background: "#f9f9f9", padding: "15px", borderRadius: 8, marginTop: 10 }}>
                <p style={{ fontSize: 15, marginBottom: 0 }}>
                  The timer is still running –{" "}
                  <span style={{ fontWeight: 600 }}>{formatTime(liveTimeLeft || timeLeftRef.current)}</span>
                </p>
              </div>
              <button
                className="btn btn-primary mt-3"
                style={{ background: "#F75891", border: "none" }}
                onClick={handleProctoringAcknowledge}
              >
                I Understand
              </button>
            </>
          ) : (
            <>
              {violationSummaryLoading ? (
                <div className="d-flex justify-content-center align-items-center my-3" style={{ gap: 8 }}>
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span style={{ fontSize: 14, color: "#555" }}>Loading violation summary...</span>
                </div>
              ) : violationSummary ? (
                <>
                  {/* Violation alert */}
                  <div style={{ background: "#fff5f5", border: "1px solid #fdd", borderRadius: 8, padding: "10px 14px", marginBottom: 14, textAlign: "left" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#d9534f", fontWeight: 600, fontSize: 14 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                      Violation detected
                    </div>
                    <p style={{ fontSize: 13, color: "#666", marginBottom: 0, marginTop: 4 }}>You left fullscreen mode. Please return to continue.</p>
                  </div>

                  {/* Section label */}
                  <p style={{ fontWeight: 700, fontSize: 11, color: "#999", letterSpacing: "0.08em", textTransform: "uppercase", textAlign: "left", marginBottom: 10 }}>Violation Summary</p>

                  {/* 2×2 card grid */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14 }}>
                    {/* Tab Switches */}
                    <div style={{ border: "1px solid #e8e8e8", borderRadius: 10, padding: "14px 16px", textAlign: "left" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 6, background: "#f0f0f0" }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                        </span>
                        <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Tab Switches</span>
                      </div>
                      <div style={{ fontSize: 26, fontWeight: 700, color: "#222", lineHeight: 1 }}>
                        {violationSummary.navigationViolationCount}<span style={{ fontSize: 16, color: "#888" }}>/{violationSummary.navigationViolationLimit}</span>
                      </div>
                      <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>{violationSummary.remainingNavigationAllowed} more allowed</div>
                    </div>

                    {/* Webcam Violations */}
                    <div style={{ border: "1px solid #e8e8e8", borderRadius: 10, padding: "14px 16px", textAlign: "left" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 6, background: "#f0f0f0" }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>
                        </span>
                        <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Webcam Violations</span>
                      </div>
                      <div style={{ fontSize: 26, fontWeight: 700, color: "#222", lineHeight: 1 }}>{violationSummary.webcamViolationCount}</div>
                      <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>Total detected</div>
                    </div>

                    {/* Exit Duration */}
                    <div style={{ border: "1px solid #e8e8e8", borderRadius: 10, padding: "14px 16px", textAlign: "left" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 6, background: "#f0f0f0" }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        </span>
                        <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Exit Duration</span>
                      </div>
                      <div style={{ fontSize: 26, fontWeight: 700, color: "#222", lineHeight: 1 }}>{violationSummary.testWindowViolationTime}<span style={{ fontSize: 14, color: "#888" }}>s</span></div>
                      <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>Total outside</div>
                    </div>

                    {/* Browsers Used */}
                    <div style={{ border: "1px solid #e8e8e8", borderRadius: 10, padding: "14px 16px", textAlign: "left" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 6, background: "#f0f0f0" }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                        </span>
                        <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Browsers Used</span>
                      </div>
                      <div style={{ fontSize: 26, fontWeight: 700, color: "#222", lineHeight: 1 }}>{violationSummary.browsersUsed}</div>
                      <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>Instance detected</div>
                    </div>
                  </div>

                  {/* Info banner */}
                  <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#eef4ff", border: "1px solid #c9daf8", borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: "#3366cc", textAlign: "left" }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    Return to fullscreen to continue your assessment
                  </div>
                </>
              ) : null}

              <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                <button
                  className="btn btn-primary"
                  style={{ background: "#F75891", border: "none", flex: 1, padding: "10px 0" }}
                  disabled={violationSummaryLoading}
                  onClick={() => {
                    handleReturnToTest();
                    goFullScreen();
                  }}
                >
                  Return to Fullscreen
                </button>
                <button
                  className="btn"
                  style={{ background: "#f0f0f0", border: "1px solid #ddd", color: "#555", padding: "10px 16px" }}
                  disabled={violationSummaryLoading}
                  onClick={handleReturnToTest}
                >
                  ✕
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={showViolationLimitPopup}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="text-center p-4">
          <h3 style={{ fontWeight: 600, color: "#D9534F" }}>
            Violation Limit Exceeded
          </h3>
          <p style={{ fontSize: 16, marginTop: 10 }}>
            You have exceeded the allowed violations.
            You cannot proceed further in this assessment.
          </p>

          <button
            className="btn btn-primary mt-3"
            style={{ background: "#F75891", border: "none" }}
            onClick={() => {
              violationLimitExceededRef.current = false;
              setShowViolationLimitPopup(false);
              setActive("feedback");
            }}
          >
            Close
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCameraErrorPopup}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="text-center p-4">
          <h3 style={{ fontWeight: 600, color: "#D9534F" }}>
            Camera Access Error
          </h3>
          <p style={{ fontSize: 16, marginTop: 10 }}>
            We were unable to capture your webcam image. This may be due to a
            camera permission issue or a technical problem. Please reload the
            page to restore camera access and continue the test.
          </p>
          <button
            className="btn btn-primary mt-3"
            style={{ background: "#F75891", border: "none" }}
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        show={showExtendedDurationPopup}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="extended-duration-modal"
      >
        <Modal.Body className="text-center p-4">
          <h3 style={{ fontWeight: "600", color: "#333" }}>Extended Time Available</h3>
          <hr />
          <p style={{ fontSize: 16, color: "#555" }}>
            Your test time has ended. You have{" "}
            <strong>{Math.ceil(extendedDurationRef.current.remaining / 60)}</strong> minute
            {Math.ceil(extendedDurationRef.current.remaining / 60) !== 1 ? "s" : ""} of extended
            time available. Would you like to use it?
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginTop: 16 }}>
            <button
              className="btn"
              style={{ background: "#aaa", color: "#fff", padding: "8px 24px", border: "none", borderRadius: 4 }}
              onClick={() => {
                setShowExtendedDurationPopup(false);
                onTimesUp();
              }}
            >
              No
            </button>
            <button
              className="btn"
              style={{ background: "#F75891", color: "#fff", padding: "8px 24px", border: "none", borderRadius: 4 }}
              onClick={startExtendedTimer}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {(active === "resuming" || languageReturnLoading) && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "#0b0b0b",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            zIndex: 9999,
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Spinner animation="border" variant="light" />
            <p style={{ marginTop: 12 }}>
              Syncing your test progress…
            </p>
          </div>
        </div>
      )}

      {showReportModal && (
        <div
          className="upload-modal"
          style={{ zIndex: 2000 }}
          onClick={(e) => { if (e.target === e.currentTarget) { closeReportModal(); } }}
        >
          <div className="modal-content" style={{ width: 460, maxWidth: "95vw" }}>
            <div className="modal-head">
              <div></div>
              <h3>Report Issue</h3>
              <img
                src="/images/close-icon.svg"
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={() => { closeReportModal(); }}
              />
            </div>
            <div className="modal-input d-flex flex-column align-items-start" style={{ gap: 14, padding: 15 }}>
              <p style={{ margin: 0, fontSize: 13.5, color: "#6b7280" }}>
                Help us improve by reporting any issues with this question.
              </p>
              <div style={{ width: "100%" }}>
                <label style={{ display: "block", fontSize: 14, fontWeight: 700, marginBottom: 8, color: "#0b0b0c" }}>
                  Issue Type <span style={{ color: "#f75891" }}>*</span>
                </label>
                <select
                  value={reportIssueType}
                  onChange={(e) => { setReportIssueType(e.target.value); setReportIssueTypeError(""); }}
                  style={{
                    width: "100%",
                    border: reportIssueTypeError ? "1.5px solid #f75891" : "1.5px solid #d1d5db",
                    borderRadius: 10,
                    padding: "11px 14px",
                    fontSize: 14,
                    color: reportIssueType ? "#0b0b0c" : "#9ca3af",
                    background: "#fff",
                    outline: "none",
                  }}
                >
                  <option value="" disabled>Select an issue type</option>
                  <option value="Wrong Question">Wrong Question</option>
                  <option value="Wrong Answer">Wrong Answer</option>
                  <option value="Question Not Visible">Question Not Visible</option>
                  <option value="Image/Code Missing">Image/Code Missing</option>
                  <option value="Technical Issue">Technical Issue</option>
                  <option value="Other">Other</option>
                </select>
                {reportIssueTypeError && (
                  <small style={{ color: "#f75891", fontSize: 12.5, marginTop: 4, display: "block" }}>{reportIssueTypeError}</small>
                )}
              </div>
              <div style={{ width: "100%", position: "relative" }}>
                <label style={{ display: "block", fontSize: 14, fontWeight: 700, marginBottom: 8, color: "#0b0b0c" }}>
                  Additional Details <span style={{ color: "#f75891" }}>*</span>
                </label>
                <textarea
                  value={reportDescription}
                  onChange={(e) => { setReportDescription(e.target.value); setReportDescriptionError(""); }}
                  maxLength={500}
                  placeholder="Please describe the issue..."
                  rows={4}
                  style={{
                    width: "100%",
                    border: reportDescriptionError ? "1.5px solid #f75891" : "1.5px solid #d1d5db",
                    borderRadius: 10,
                    padding: "11px 14px 28px",
                    fontSize: 14,
                    resize: "vertical",
                    fontFamily: "inherit",
                    background: "#fff",
                    color: "#0b0b0c",
                    outline: "none",
                  }}
                />
                <span style={{ position: "absolute", bottom: 10, right: 12, fontSize: 12, color: "#9ca3af", pointerEvents: "none" }}>
                  {reportDescription.length}/500
                </span>
                {reportDescriptionError && (
                  <small style={{ color: "#f75891", fontSize: 12.5, marginTop: 4, display: "block" }}>{reportDescriptionError}</small>
                )}
              </div>
              <div style={{ background: "#ffe7ee", border: "1px solid #fbc6d4", color: "#b1264c", padding: "10px 14px", borderRadius: 10, fontSize: 12.5, lineHeight: 1.5, display: "flex", alignItems: "flex-start", gap: 10, width: "100%" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 2 }}>
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <div>
                  Your report will be submitted without interrupting your test.<br />
                  You can continue with the test.
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center" style={{ gap: 12, paddingBottom: 15 }}>
              <button
                className="submit-btn"
                onClick={() => { closeReportModal(); }}
                style={{ backgroundColor: "#aaa", cursor: "pointer" }}
              >
                Cancel
              </button>
              <button
                className="submit-btn"
                onClick={handleReportSubmit}
                disabled={reportSubmitting}
                style={{ backgroundColor: reportSubmitSuccess ? "#1B8E3E" : "#f75891", cursor: reportSubmitting ? "not-allowed" : "pointer" }}
              >
                {reportSubmitSuccess ? "Submitted ✓" : reportSubmitting ? "Submitting..." : "Submit Report"}
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}